(function () {
  var __env = {
    enableDebug: false
  };

  // Import variables if present (from env.js)
  // For some reason Object.assign did not work.
  if (window) {
    __env = Lazy(__env).assign(window.__env).value();
  }

  /* Individual svg files supplied by scmw. */
  var svgs = {
    'scmw:delete': 'assets/img/delete.svg',
    'scmw:face-profile': 'assets/img/face-profile.svg',
    'scmw:face': 'assets/img/face.svg',
    'scmw:glasses': 'assets/img/glasses.svg',
    'scmw:new-box': 'assets/img/new-box.svg',
    'scmw:truck': 'assets/img/truck.svg',
    'scmw:note-text': 'assets/img/note-text.svg',
    'scmw:note-plus': 'assets/img/note-plus.svg'
  };

  angular
    .module('app', ['ngCookies', 'ngMaterial', 'ngMessages',
      'ngResource', 'ui.router'])
    .constant('__env', __env)
    .config(configIndex)
    .run(runIndex);

  configIndex.$inject = ['$logProvider', '$mdIconProvider',
    '$mdThemingProvider'];
  /**
   * Configure the app.
   *
   * @param {Object} $logProvider
   * @param {Object} $mdIconProvider angular-mater icons
   * @param {Object} $mdThemingProvider angular-material theming
   */
  function configIndex($logProvider, $mdIconProvider, $mdThemingProvider) {
    /* Disable logging */
    $logProvider.debugEnabled(__env.enableDebug);

    /* Supply an svg-id to the <md-icon>. */
    /* Use mdi.svg sparingly bc the performance loading many icons at once
      is not that great. */
    $mdIconProvider
      .defaultIconSet('assets/img/mdi.svg');

    /* Register icon in a specific set */
    angular.forEach(svgs, function (value, key) {
      $mdIconProvider.icon(key, value);
    });

    /* The colours */
    $mdThemingProvider.theme('default')
      .primaryPalette(__env.primaryPalette || 'light-blue')
      .accentPalette(__env.accentPalette || 'orange');

    $mdThemingProvider.theme('dark-default')
      .primaryPalette(__env.primaryPalette || 'light-blue')
      .accentPalette(__env.accentPalette || 'orange')
      .backgroundPalette(__env.primaryPalette || 'light-blue')
      .dark();
  } /* configIndex */

  runIndex.$inject = ['$log', '$templateRequest', '__env'];
  /**
   * Run things on start-up.
   *
   * @param {Object} $log something for logging
   * @param {Object} $templateRequest the angular-material template cacheing
   * @param {Object} __env the per-site environmental variables
   */
  function runIndex($log, $templateRequest, __env) {
    $log.debug("Ready!", JSON.stringify(__env));

    /* Change the head/title. */
    document.title = __env.title || 'SCMW';

    /* Pre-fetch and cache SVG icons. This does not seem to speed up
      md-icon that much. */
    angular.forEach(svgs, function (value) {
      $templateRequest(value);
    });
  } /* runIndex */
})();

(function () {
  angular
    .module('app')
    .filter('whomin', whominFilter);

  /**
   * Obtain a function that extracts reduces a list of contacts and/or injects
   * a dummy contact.
   *
   *     whom + zoom-in = whomin
   *
   * whominFilter works differently than most filters because it injects
   * a dummy result representing a custom user that matches exactly what the
   * web user filled in as a query.   This dummy result means the web user
   * can send messages to anyone they want.
   *
   */
  function whominFilter() {
    /**
     * Contacts would like something like this:
     *
     * [
     *     {scmid: 'bob', name: 'Bob'},
     *     {scmid: 'wil@szeto.ca', name: 'The Wil'},
     *     {scmid: 'chucky', name: 'Chucky'},
     *     {scmid: 'wilber@bell.ca', name: 'Wilber Bell'},
     *     {scmid: 'duke', name: 'Duke'}
     * ]
     *
     * The returned value might look like the following:
     *
     *    [
     *       {scmid: 'wil@szeto.ca', name: 'The Wil'},
     *       {scmid: 'wilber@bell.ca', name: 'Wilber Bell'},
     *       {scmid: 'wilma@ibm.com', name: 'Wilma IBM'}
     *    ]
     *
     * @param {Array} contacts a list of SCMW/reserialized users
     * @param {String} needle the needle to look for
     * @return {Array} a list of SCMW/reserialized users
     */
    return function (contacts, needle) {
      if (!contacts || 0 >= contacts.length) {
        return [{scmid: needle}];
      }
      var query = needle.toLowerCase();

      /* Perfect Match */
      var matches = Lazy(contacts)
        .filter(function (user) {
          return ((user.name && (user.name.toLowerCase() === query))
            || (user.scmid.toLowerCase() === query));
        })
        .value();

      if (matches && 0 < matches.length) {
        return matches;
      }

      /* Partial Match */
      var matches = Lazy(contacts)
        .filter(function (user) {
          var possible1;
          var possible2;

          if (user.scmid) {
            possible1 = Lazy(user.scmid.toLowerCase()).contains(query);
          }
          if (user.name) {
            possible2 = Lazy(user.name.toLowerCase()).contains(query);
          }
          return (possible1 || possible2);
        });

      /* Zero partial matches */
      if (!matches || 0 >= matches.length) {
        return [{scmid: needle}];
      }

      /* Partial matches and the query user itself */
      return Lazy(matches).concat([{scmid: needle}]).value();
    }; /*function*/
  } /* initialsFilter */
})();

(function () {
  angular
    .module('app')
    .constant('__version__', '18.05.1');
})();

(function() {
  angular.module('app')
    .directive('verifyPassword', verifyPassword);


  verifyPassword.$inject = ['$q', 'scmService'];
  /**
   * The verify-password directive verifies a password is valid.
   *
   * The verify-password directive checks the password entered into presumably
   * an <input> with the SCMAPI server.
   *
   * @param {Object} $q the promise provider
   * @param {Object} scmService the SCMAPI service
   */
  function verifyPassword($q, scmService) {
    var ddo = {
      require: 'ngModel',
      link: linkFunc,
      restrict: 'A'
    };

    return ddo;

    function linkFunc(scope, el, attr, ctrl) {
      ctrl.$asyncValidators.verifyPassword = verifyPasswordValidator;

      /**
       * Verify the ng-model against the SCM API.
       *
       * The returned promise will resolve with true or will reject with
       * an error message.
       *
       * @param {String} modelValue the current value of the ng-model
       * @param {String} viewValue the value entered into the view
       * @return a promise to verify the password
       */
      function verifyPasswordValidator(modelValue, viewValue) {
        if (ctrl.$isEmpty(modelValue)) {
          // consider empty model valid
          return $q.when();
        }

        var def = $q.defer();
        scmService.verifyPassword(modelValue)
          .then(function (result) {
            console.log(result);
            if (result.accepted) {
              def.resolve('Authorized');
            } else {
              def.reject('Unauthorized');
            }
          })
          .catch(function (error) {
            console.log(error);
            def.reject(error);
          });

        return def.promise;
      } /* verifyPasswordValidator */
    } /* linkFunc */
  } /* verifyPassword */
})();

(function () {
  angular
    .module('app')
    .filter('toToiOuMoi', toToiOuMoiFilter);

    /**
     * Obtain a function that filters the recipients leaving only the recipients
     * that match needle1 and needle2 where needle1 and needle2 are scmids.
     * 
     *
     */
  function toToiOuMoiFilter() {
    /**
     * Filter out only the tos that needle1 and needle2 are a recipient of.
     *
     * @param {Array} toScmids the message.to_scmids
     * @param {string} needle1 possible recipient
     * @param {string} needle2 possible recipient
     * @return {Array} an array of toScmid
     */
    return function (toScmids, needle1, needle2) {
      return (needle1 && needle2)
        ? Lazy(toScmids).filter(lazyToiOuMoi).value() : [];

      /**
       * Are either needle1 or needle2 a recipient in the to_scmids?
       *
       * @param toScmid a single object in message.to_scmids array
       * @return true=needle1 or needle2 is a recipient, false=not a recipient
       */
      function lazyToiOuMoi(toScmid) {
        return (toScmid.scmid === needle1 || toScmid.scmid === needle2);
      } /* lazyToiOuMoi */
    };
  } /* toToiOuMoiFilter */
})();

(function () {
  angular
    .module('app')
    .filter('toAndFrom', toAndFromFilter);

  /**
   * Obtain a function that filters out the messages that are either to or
   * from the madatory needle scmid.
   *
   */
  function toAndFromFilter() {
    return function (messages, needle) {
      return (needle) ? Lazy(messages).filter(lazyToAndFrom).value() : [];

      /**
       * Does the message have the needle as a to or a from?
       *
       * @param message a SCMAPI message object, the whole shebang
       * @return true=yes needle is apart of to/from, false=no needle
       */
      function lazyToAndFrom(message) {
        if (message.from_scmid.scmid === needle) {
          return true;
        }

        var found = Lazy(message.to_scmids)
          .find(function (toScmid) {
            return (toScmid.scmid === needle);
          });

        if (found) {
          return true;
        }

        return false;
      } /* lazyToAndFrom */
    }; /* return */
  } /* filtToAndFrom */
})();

(function () {
  angular
    .module('app')
    .filter('tail', tailFilter);

  /**
   * Get the last element in the array.
   *
   * @param {Array} arry an array of some kind
   * @return the last item in the array.
   */
  function tailFilter() {
    return function (arry) {
      return Lazy(arry).last();
    }
  } /* tailFilter */
})();

(function () {
  angular
    .module('app')
    .factory('scmService', ScmService);

  ScmService.$inject = ['$cookies', '$http', '$log', '$q', '$resource',
    '$rootScope', '$timeout', '__env', 'SCMSTAT', 'scmTr'];
  /**
   * The ScmService does 2 things:
   *
   * 1.  ScmService makes requests to the SCMAPI.
   * 2.  ScmService caches the whole lot of messages.
   *
   * @param {Object} $cookies angular $cookies provider
   * @param {Object} $http angular $http provider
   * @param {Object} $log the angular log object
   * @param {Object} $q angular promise provider
   * @param {Object} $resource angular $resource provider
   * @param {Object} $rootScope the angular $rootScope.
   * @param {Object} $timeout angular timeout provider
   * @param {Object} __env the scmw window environment
   * @param {Object} SCMSTAT the scm delivered,unread,deleted statuses
   * @param {Object} scmTr the scm transform service
   */
  function ScmService($cookies, $http, $log, $q, $resource,
    $rootScope, $timeout, __env, SCMSTAT, scmTr) {
    /**
     * The most important piece of data, ie the list of messages.
     *
     */
    var _messages = [];

    /* The ordered list of contacts from SCMAPI */
    var _contacts = [];
    var _contactLookup = {};

    return {
      moi: getMoi,
      signout: signout,
      signin: signin,
      getEvents: getEvents,
      acknowledgeEvents: acknowledgeEvents,
      submit: submit,
      markMessagesDelivered: markMessagesDelivered,
      markMessagesRead: markMessagesRead,
      deleteMessages: deleteMessages,
      loadAllMessages: loadAllMessages,
      addNote: addNote,
      getNote: getNote,
      verifyPassword: verifyPassword,
      changePassword: changePassword,
      getContacts: getContacts,
      fuseContacts: fuseContacts
    };

    /**
     * Who am I?  Who is the web-user?
     *
     * @return {string} who the logged in scmid is
     */
     function getMoi() {
       return $cookies.get('moi');
     }

     /**
      * Clear out all memory (including the messages) and clear out all cookies.
      *
      * Emit the "scm:authentication event with an error.
      *
      * @param {string} error the error, or non-error text
      * @return {string} who the logged in scmid is
      */
     function signout(error) {
       $cookies.put('moi', null);
       $cookies.put('utoken', null);

       _messages = [];

       if (angular.isObject(error)) {
         error = "I had trouble communicating with server.";
       } else if (!angular.isString(error)) {
         error = "Login failed";
       }

       /* Emit the explicit logout. */
       $rootScope.$emit("scm:authentication", {error: error});
     }

     /**
      * Obtain some random strings.
      *
      *
      * @return: a random sequence of strings.
      */
     function _s4() {
       return Math.floor((1 + Math.random()) * 0x10000)
         .toString(16)
         .substring(1);
     }

    /**
     * Ask SCMAPI for a utoken.
     *
     * If SCMAPI supplies a utoken then save the utoken as a cookie.
     *
     * On successful log in emit the "scm:authentication" event.
     *
     * @param {string} username the user-name aka the scmid
     * @param {string} password  the password
     * @return a promise that once ful-filled will have the API result.
     */
    function signin(username, password) {
      var deferred = $q.defer();

      /* Obtain a regid */
      var regid = localStorage.getItem('regid');
      if (!regid) {
        $log.debug("I need to generate a regid");
        regid = 'scmw-' + _s4() + _s4() + '-' + _s4() + '-' + _s4() + '-'
          + _s4() + '-' + _s4() + _s4() + _s4();
        localStorage.setItem('regid', regid);
      }
      $log.debug("regid =", regid);

      $log.debug(username, password);
      deferred.notify('Sending signin to', __env.apiUrl || '/scmapi/');
      $http.defaults.headers.common.Authorization
        = 'Basic ' + btoa(username + ':' + password);
      $resource(__env.apiUrl || '/scmapi/')
        .save(null, {
          command: "240903c72b92d2c971cd71d9699d11666df09e98",
          regid: regid,
          regtype: "clx"
        })
        .$promise
        .then(function (result) {
          if (result.utoken) {
            $cookies.put('moi', username, _getCookieOptions());
            $cookies.put('utoken', result.utoken, _getCookieOptions());
            deferred.resolve(result);

            _messages = [];
            /* Emit a successful login */
            $rootScope.$emit("scm:authentication", {
              option: {}
            });
          } else {
            _messages = [];
            deferred.reject(result.error || 'Login failed but I am not sure why');
          }
        })
        .catch(function (error) {
          $cookies.put('moi', null);
          $cookies.put('utoken', null);
          $log.debug(error);
          deferred.reject("I could not send login");
          _messages = [];
        });

      return deferred.promise;
    } /* signin */

    /**
     * Obtain the cookie options that expire the cookie in 3 hours.
     *
     * Pass the returned object to $cookie.put().
     *
     * @return {Object} the options for $cookie.put().
     */
    function _getCookieOptions() {
      var options = {};

      if (!__env.enableDebug) {
        var expires = new Date();
        expires.setTime(expires.getTime() + 3 * 60 * 60 * 1000);
        options = {
          secure: true,
          expires: expires
        };
      }

      return options;
    }

    /**
     * Obtain a $resource "class" object that can "send".
     *
     * SCMAPI expects a utoken.
     *
     * @return a $resource "class" that can "send"
     */
    function _allResource() {
      var username = $cookies.get('moi');
      var utoken = $cookies.get('utoken');

      $http.defaults.headers.common.Authorization
        = 'Basic ' + btoa(utoken + ':' + 'secret');
      return $resource(__env.apiUrl || '/scmapi/', null, {
        send: {method: 'POST'}
      });
    }

    /**
     * Load all of the messages.
     *
     * Begin polling too iff SCMAPI responds successfully.
     *
     *
     *
     *
     * @return {Promise} a promise to get a list of messages
     */
    function loadAllMessages() {
      var deferred = $q.defer();

      if (_messages.length) {
        deferred.resolve(_messages);
        return deferred.promise;
      }

      _allResource()
        .send({
          command: "998ba7d9e191ee67b2d54baefa563ed4bf28859c"
        })
        .$promise
        .then(function (result) {
          if (result.accepted) {
            Lazy(result.messages).each(function (message) {
              $log.debug(message);
              message.note = {};
            });

            Array.prototype.push.apply(_messages, result.messages);
            _pollEvents();
            return _loadAllNotes();
          } else {
            _messages = [];
            _handleNotAccepted(result, deferred, 'Failed to load messages');
          }
        })
        .then(function (notes) {
          return getContacts();
        })
        .then(function (contacts) {
          deferred.resolve(_messages);
        })
        .catch(function (error) {
          if (0 >= _messages.length) {
            signout("Sign in");
            deferred.reject(error);
          } else {
            deferred.resolve(_messages);
          }
        });

      return deferred.promise;
    } /* loadAllMessages */

    /**
     * Load all of the notes and then integrate the notes into the _messages.
     *
     *
     *
     * @return {Promise} a promise to get a list of notes.
     */
    function _loadAllNotes() {
      var deferred = $q.defer();

      _allResource()
        .send({
          command: '7b727c842a7c414e1254c534b9e54ce9d3ad5378'
        })
        .$promise
        .then(function (result) {
          if (result.accepted) {
            Lazy(result.notes).each(function (note) {
              $log.debug(note);

              var message = Lazy(_messages).find(function (message) {
                return (message.mid === note.mid);
              });

              if (message) {
                message.note = note;
              }
            });

            deferred.resolve(result.notes);
          } else {
            _messages = [];
            _handleNotAccepted(result, deferred, 'Failed to load messages');
          }
        })
        .catch(function (error) {
          _messages = [];
          deferred.reject(error);
        });
    } /* _loadAllNotes */

    /**
     * Run getEvents() over and over and over.
     *
     *
     */
    function _pollEvents() {
      getEvents()
        .then(function(result) {
          $timeout(_pollEvents, (__env.enableDebug) ? 10000:4000);
        });

      return;
    }

    /**
     * Ask SCMAPI for events.
     *
     * Events are automatically acknowledged.
     *
     * @return {Promise} a promise to get the API events result same as API
     */
    function getEvents()
    {
      var deferred = $q.defer();

      _allResource()
        .send({
          command: "getevents"
        })
        .$promise
        .then(function (result) {
          if (result.events) {
            /* Handle new messages. */
            Lazy(result.events)
              .async()
              .filter(function (event) {
                return ("new" === event.action);
              })
              .each(_handleNewEvents);

            /* Handle the message delivered, read, deleted changes. */
            Lazy(result.events)
              .async()
              .filter(function (event) {
                return ("new" !== event.action);
              })
              .each(_handleStatusEvents);

            /* Automatically acknowlege all the events */
            var eids = Lazy(result.events).map(function (event) {
              return event.eid;
            }).value();
            acknowledgeEvents(eids);

            deferred.resolve(result);
          } else {
            _handleNotAccepted(result, deferred, 'Get events failed');
          }
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    /**
     * Handle the "new" SCMAPI event.
     *
     * The "new" event says there is a new message.  The event is exactly a
     * message but with a few extra properties.
     *
     * <pre><code>
     * {
     *   scmid: 'wil@szeto.ca',
     *   created: '1469636819',
     *   mid: '4',
     *   from_scmid: {
     *     status: 2,
     *     scmid: 'wil@szeto.ca'
     *   },
     *   to_scmids: [{
     *     status: 0,
     *     scmid: 'call_linx@szeto.ca'
     *   }],
     *   eid: '39',
     *   action: 'new',
     *   message: 'Hello World',
     *   ecreated: '1469636819'
     * }
     * </code></pre>
     *
     * @param {Object} event an event with a new action action
     */
    function _handleNewEvents(event) {
      if ('new' === event.action) {
        $log.debug("Pushing", JSON.stringify(event));

        /* Start the new message without any note in preparation for getnote */
        event.note = {};

        /* Merge the name into the froms and the tos. */
        _injectNameIntoMessage(event);

        /* Add to the messages */
        _messages.push(event);

        /* The user may have already added a note using another device so
         * load it up here. */
        getNote(event.mid);
        return;
      }
    }

    /**
     * Handle change in status events.
     *
     * Set the message to and from to be exactly the event's to and from.
     *
     * <code><pre>
     *
     *   {
     *     "eid": "465",
     *     "ecreated":"1469823455",
     *     "scmid":"gil@szeto.ca",
     *     "action":"delivered",
     *     "mid":"54",
     *     "from_scmid":{"scmid":"wil@szeto.ca","status":2},
     *     "to_scmids":[{"scmid":"gil@szeto.ca","status":1}],
     *     "created":null,"message":null
     * }
     *
     * or
     *
     *   {
     *      "eid":"468",
     *      "ecreated":"1469823455",
     *      "scmid":"gil@szeto.ca",
     *      "action":"read",
     *      "mid":"54",
     *      "from_scmid":{"scmid":"wil@szeto.ca","status":2},
     *      "to_scmids":[{"scmid":"gil@szeto.ca","status":2}],
     *      "created":null,
     *      "message":null
     *   }
     *
     * </code></pre>
     *
     *
     * @param {Object} event an event with a change status action
     */
    function _handleStatusEvents(event) {
      Lazy(_messages)
        .filter(function (message) {
          return (message.mid === event.mid);
        })
        .each(function (message) {
          message.to_scmids = event.to_scmids;
          message.from_scmid = event.from_scmid;
          _injectNameIntoMessage(message);
        });

      return;
    }

    /**
     * Acknowledged the events matching the eids.
     *
     *
     * @param {Array} eids an array of integers
     * @return {Promise} a promise to send the command
     */
    function acknowledgeEvents(eids)
    {
      var deferred = $q.defer();

      if (0 >= eids.length) {
        deferred.resolve({accepted: true});
        return deferred;
      }

      _allResource()
        .send({
          command: "sendeventsack",
          eids: eids
        })
        .$promise
        .then(function (result) {
          if (result.accepted) {
            deferred.resolve(result);
          } else {
            _handleNotAccepted(result, deferred, 'Acknowledge events failed');
          }
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    }

    /**
     * Submit a message.
     *
     *
     *
     * @param {Array} scmids whom to send the message, array of strings
     * @param {string} message what should be said
     * @return {Promise} a promise to send the msg and get the submitted msg
     */
    function submit(scmids, message) {
      var deferred = $q.defer();

      _allResource()
      .send({
        command: "sendmessage",
        to_scmids: scmids,
        message: message
      })
      .$promise
      .then(function (result) {
        /*
         *
         * result = {
         *   "accepted":true,
         *   "message": {
         *     "mid":"50",
         *     "created": "1469821232",
         *     "to_scmids": [{"scmid":"wil@szeto.ca","status":2}]
         *   }
         * }
         *
         */
        if (result.message) {
          /* Inject the from_scmid bc scmapi omits these in the result. */
          var madeUp = {
            from_scmid: {
              scmid: $cookies.get('moi'),
              status: SCMSTAT.READ
            },
            message: message
          };

          _injectNameIntoMessage(result.message);
          _messages.push(Lazy(madeUp).merge(result.message).value());
          deferred.resolve(result.message);
        } else {
          _handleNotAccepted(result, deferred, 'Send message failed');
        }
      })
      .catch(function (error) {
        $log.debug(error);
        deferred.reject(error);
      });

      return deferred.promise;
    }

    /**
     * Adjust the local copy of the message matching mids to the given status.
     *
     *
     * @param {Array} mids an array of message ids
     * @param {int} status the status
     * @return Nada
     */
    function _adjustStatus(mids, status) {
      var moi = $cookies.get('moi');
      var midSequence = Lazy(mids);
      Lazy(_messages)
        .filter(function (message) {
          return midSequence.contains(message.mid);
        })
        .each(function (message) {
          if (message.from_scmid.scmid == moi) {
            message.from_scmid.status = status;
          }

          var toScmid = Lazy(message.to_scmids).find(function (toScmid) {
            return (toScmid.scmid === moi);
          });

          if (toScmid) { toScmid.status = status; }
        });

      return;
    }

    /**
     * Mark the message delivered on the server-side and locally.
     *
     * @param {Array} mids mark delivered the msgs matching this list of mids
     * @return {Promise} a promise to get the mark-delivered-message result
     */
    function markMessagesDelivered(mids) {
      var markDelivered = $q.defer();

      _allResource()
        .send({
          command: "markmessagesdelivered",
          mids: mids
        })
        .$promise
        .then(function (result) {
          if (result.accepted) {
            _adjustStatus(mids, SCMSTAT.DELIVERED);
            markDelivered.resolve(result);
          } else {
            _handleNotAccepted(result, deferred, 'Mark delivered read failed');
          }
        })
        .catch(function (error) {
          $log.debug(error);
          markDelivered.reject(error);
        });
      return markDelivered.promise;
    } /* markMessagesDelivered */

    /**
     * Mark the message read on the server-side and locally.
     *
     * @param {Array} mids mark read the messages matching this list of mids
     * @return {Promise} to get the mark-messages-read result
     */
    function markMessagesRead(mids) {
      var deferred = $q.defer();

      _allResource()
        .send({
          command: "markmessagesread",
          mids: mids
        })
        .$promise
        .then(function (result) {
          if (result.accepted) {
            _adjustStatus(mids, SCMSTAT.READ);
            deferred.resolve(result);
          } else {
            _handleNotAccepted(result, deferred, 'Mark message read failed');
          }
        })
        .catch(function (error) {
          $log.debug(error);
          deferred.reject(error);
        });

      return deferred.promise;
    } /* markMessagesRead */

    /**
     * Delete the messages matching the given mids.
     *
     *
     * @param {Array} mids a list of message mid, a list of integers
     * @return {Promise} a promise to send the delete message command.
     */
    function deleteMessages(mids) {
      var deferred = $q.defer();

      _allResource()
        .send({
          command: "deletemessages",
          mids: mids
        })
        .$promise
        .then(function (result) {
          if (result.accepted) {
            _adjustStatus(mids, SCMSTAT.DELETED);
            deferred.resolve(result);
          } else {
            _handleNotAccepted(result, deferred, 'Delete message failed');
          }
        })
        .catch(function (error) {
          $log.debug(error);
          deferred.reject(error);
        });

      return deferred.promise;
    } /* deleteMessages */

    /**
     * Handle things that were not accepted.
     *
     * <code><pre>
     *
     *   response = {
     *     "accepted":false,
     *     "error":"Unauthorized.",
     *     "error_code":401
     *   }
     *
     * </pre></code>
     *
     * @param {Object} response an object with accepted/error
     * @param {$q.defer()} deferred the deferred to reject
     * @param {string} dflErrorMsg what to say if SCMAPI said nothing
     */
    function _handleNotAccepted(response, deferred, dflErrorMsg) {
      if (response.accepted) {
        deferred.reject(response);
        return;
      }

      $log.debug('scmService._handleNotAccepted()', response, '.');
      if (response.error_code) {
        if (401 === response.error_code || '401' === response.error_code) {
          /* If there are 0 messages, the program must be 1st loading up
            and if so then the login should display 0 error messages. */
          signout((_messages.length > 0) ? response.error : '');
        }
      }

      deferred.reject(response.error, dflErrorMsg);
    } /* _handleNotAccepted */

    /**
     * Add a note to the message matching mid.
     *
     *
     * @param {int} mid the message presuably with a note
     * @param {String} note the note body
     * @return {Promise} a promise to save and then get the note
     */
    function addNote(mid, note) {
      var deferred = $q.defer();

      _allResource()
        .send({
          command: "addnote",
          mid: mid,
          note: note
        })
        .$promise
        .then(function (result) {
          return getNote(mid);
        })
        .then(function (note) {
          deferred.resolve(note);
        })
        .catch(function (error) {
          $log.debug(error);
          deferred.reject(error);
        });

      return deferred.promise;
    } /* addNote */

    /**
     * Obtain the note for the message matching the given mid.
     *
     * The note will be automatically integrated with the message inside
     * _messages.
     *
     * @param {int} mid the message presuably with a note
     * @return {Promise} a promise to get the note
     */
    function getNote(mid) {
      var deferred = $q.defer();

      _allResource()
        .send({
          command: "getnote",
          mid: mid
        })
        .$promise
        .then(function (result) {
          if (result.accepted) {
            var _message = Lazy(_messages).find(function (message) {
              return (message.mid === mid);
            });
            if (_message) {
              _message.note = angular.isArray(result.note) ? {}:result.note;
            }
            deferred.resolve(result.note);
          } else {
            $log.debug(result);
            deferred.reject(result);
          }
        })
        .catch(function (error) {
          $log.debug(error);
          deferred.reject(error);
        });

      return deferred.promise;
    } /* getNote */

    /**
     * Verify the password is for the web-user.
     *
     * SHA-1 calculation is provided by js-sha1:
     *
     * - https://github.com/emn178/js-sha1
     *
     * @param {String} the password to verify
     * @return {Promise} a promise to a accepted SCMAPI response.
     */
    function verifyPassword(password) {
      var hexifiedPassword = sha1(password);

      return _allResource()
        .send({
          command: '36985afca6396ca4b041a680dc68d13bc7b92075',
          password: hexifiedPassword
        })
        .$promise;
    }

    /**
     * Change the password.
     *
     * @param {String} password the old password
     * @param {String} newPasword what the new password will be
     * @return {Promise} a promise to true=success
     */
    function changePassword(password, newPassword) {
      var deferred = $q.defer();

      _allResource()
        .send({
          command: '3662ec2f8ab27b7d32a1b98fba8bfc13593ec6d2',
          oldpassword: password,
          newpassword: newPassword
        })
        .$promise
        .then(function (result) {
          if (result.accepted) {
            deferred.resolve(true);
          } else {
            deferred.reject(result.error || 'Password change rejected');
          }
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    } /* changePassword */

    /**
     * Get the curated contacts.
     *
     * SCMAPI returns in-part:
     *
     * <pre><code>
     *    [
     *        {
     *            "scmid": "bil@szeto.ca",
     *            "fullname": ""
     *        },
     *        {
     *            "scmid": "gil@szeto.ca",
     *            "fullname": ""
     *        },
     *        {
     *            "scmid": "bart.simpson",
     *            "fullname": "Bart Simpson"
     *        },
     *        {
     *            "scmid": "homer.simpson",
     *            "fullname": "Homer Simpson"
     *        },
     *        {
     *            "scmid": "lisa.simpson",
     *            "fullname": "Lisa Simpson"
     *        },
     *        {
     *            "scmid": "maggie.simpson",
     *            "fullname": "Maggie Simpson"
     *        },
     *        {
     *            "scmid": "marge.simpson",
     *            "fullname": "Marge Simpson"
     *        }
     *    ]
     * </pre></code>
     *
     * But the returned contacts will be reserialized swapping fullname with
     * name.
     *
     * <pre><code>
     *    [
     *        {
     *            "scmid": "bil@szeto.ca",
     *            "name": "",
     *            "curated": true
     *        },
     *        {
     *            "scmid": "gil@szeto.ca",
     *            "name": "",
     *            "curated": true
     *        },
     *        {
     *            "scmid": "bart.simpson",
     *            "name": "Bart Simpson",
     *            "curated": true
     *        },
     *        {
     *            "scmid": "homer.simpson",
     *            "name": "Homer Simpson",
     *            "curated": true
     *        },
     *        {
     *            "scmid": "lisa.simpson",
     *            "name": "Lisa Simpson",
     *            "curated": true
     *        },
     *        {
     *            "scmid": "maggie.simpson",
     *            "name": "Maggie Simpson",
     *            "curated": true
     *        },
     *        {
     *            "scmid": "marge.simpson",
     *            "name": "Marge Simpson",
     *            "curated": true
     *        }
     *    ]
     * </pre></code>
     *
     * @return {Promise} a promise to get a list of reserialized contacts.
     */
    function getContacts() {
      var deferred = $q.defer();

      _allResource()
        .send({
          command: 'f15bed865542db9e5326bcab750b7945e85c45c7'
        })
        .$promise
        .then(function (result) {
          if (result.accepted) {
            var contacts = scmTr.reSerializeContacts(result.contacts);
            $log.debug(contacts);
            deferred.resolve(contacts);
            _expensiveNameUpdate(contacts);
          } else {
            deferred.reject(result.error);
          }
        })
        .catch(function (error) {
          deferred.reject(error);
        });

      return deferred.promise;
    } /* getContacts */

    /**
     * Adjust any and all messages received thus far with the name (ie fullname)
     * iff the name does not already exist.
     *
     * _expensiveNameUpdate() is expensive because potentially each message
     * will be updated triggering a digest loop.
     *
     * @param {Object} contacts a reserialized contact (not a SCMAPI contact)
     */
    function _expensiveNameUpdate(contacts) {
      if (angular.equals(_contacts, contacts)) {
        return;
      }

      _contacts = contacts;

      /* Turn list into hash. */
      _contactLookup = {};
      Lazy(_contacts).each(function (contact) {
        _contactLookup[contact.scmid] = contact.name;
      });

      Lazy(_messages)
        .async()
        .each(_injectNameIntoMessage);
    } /* _expensiveNameUpdate */

    /**
     * Inject the name (ie fullname) into the message iff the name is missing.
     *
     * Each message has a from_scmid and to_scmids object similar to the
     * following:
     *
     *    from_scmid: {
     *       status: 2,
     *       scmid: 'wil@szeto.ca'
     *     },
     *     to_scmids: [{
     *       status: 0,
     *       scmid: 'call_linx@szeto.ca'
     *     }],
     *
     * _injectNameIntoMessage() will add a "name" property beside the "scmid"
     * property:
     *
     *    from_scmid: {
     *       status: 2,
     *       scmid: 'wil@szeto.ca',
     *       name:  'Wil Wong'
     *     },
     *     to_scmids: [{
     *       status: 0,
     *       scmid: 'call_linx@szeto.ca',
     *       name:  'Call Linx'
     *     }],
     *
     * Placing the name beside the scmid makes it easy for the rest of the
     * project to use either interchangeably.
     *
     * @param {Object} message a SCMAPI message structure.
     */
    function _injectNameIntoMessage(message) {
      if (!message) {
        return;
      }

      if (message.from_scmid) {
        if (!message.from_scmid.name) {
          message.from_scmid.name = _contactLookup[message.from_scmid.scmid] || '';
        }
      }

      Lazy(message.to_scmids).each(function (toScmid) {
        if (!toScmid.name) {
          toScmid.name = _contactLookup[toScmid.scmid] || '';
        }
      }); /*each*/
    } /* _injectNameInfoMessage */

    /**
     * Obtain the contacts from SCMAPI and then fuse it with the given
     * additional users.
     *
     * fuseContacts returns the samething as getContacts() but it merges
     * the getContacts() result with the given additionalUsers.
     *
     * @param {Object} additionalUsers additional users, correspondents
     * @return {Promise} a promise to get a list of reserialized contacts.
     */
    function fuseContacts(additionalUsers) {
      return getContacts()
        .then(function (contacts) {
          var correspondents = Lazy(additionalUsers)
            .filter(function (correpondent) {
              return undefined === Lazy(contacts).find(function (contact) {
                return contact.scmid === correpondent.scmid;
              });
            })
            .value();
          return Lazy(contacts).concat(correspondents).value();
        })
        .catch(function (error) {
          $log.error("Resolving contacts error:", error);
          return additionalUsers;
        });
    } /* fuseContacts */
  } /* ScmService */
})();

(function () {
  angular
    .module('app')
    .constant('SCMSTAT', {
      NEW: 0,
      DELIVERED: 1,
      READ: 2,
      DELETED: 3
    });
})();

(function () {
  angular
    .module('app')
    .config(configResource)

  /**
   * $resource does not appear to follow redirects or something bad happens
   * on 301.  Avoid 301 when the trailing slash is not quite right.
   *
   * @param $resourceProvider angular's resource-provider
   */
  function configResource($resourceProvider) {
    $resourceProvider.defaults.stripTrailingSlashes = false;
  }
})();

(function () {
  angular
    .module('app')
    .factory('scmTr', scmTr);

  scmTr.$inject = ['$log', 'SCMSTAT'];
  /**
   *
   * @param {Object} $log the angular log object
   * @param {Object} SCMSTAT the new/delivered/read statuses
   * @return {Object} the scm-transform module
   */
  function scmTr($log, SCMSTAT) {
    return {
      messagesToUserUnreadCreated: messagesToUserUnreadCreated,
      messagesToBuddyDex: messagesToBuddyDex,
      messagesToFullBuddyDex: messagesToFullBuddyDex,
      reSerializeContacts: reSerializeContacts,
      remapUsersToScmids: remapUsersToScmids
    };

    /**
     * Turns an array of messages into:
     *
     * <code><pre>
     *   {
     *      'wil@szeto.ca':  {count: 1, created: '1234567890', name: 'Wil W'}
     *      'bil@szeto.ca':  {count: 20, created: '2345678901', name: 'Bil B'}
     *      'gil@szeto.ca':  {count: 300, created: '3456789012', name: 'Gil G'}
     *   }
     * </pre></code>
     *
     * @param {Array} messages a list of messages
     * @return {Object} the unique users and the unread messages.
     */
    function messagesToUserUnreadCreated(messages, moi) {
      return Lazy(messages)
        .reduce(_reduceByName(moi), {});
    } /* messagesToUserUnreadCount */

    /**
     * Obtain a function that reduces the message to the user-name and unread
     * count array.
     *
     * @param {string} moi the person presumably logged in.
     * @return {Function} the function
     */
    function _reduceByName(moi) {
      /**
       * Reduce to count array.
       *
       * Starting off:
       *
       *   reduction = {}
       *
       * After 1st message bil wrote wil but wil has not read yet.:
       *
       *   reduction = {
       *     wil: {count: 0, created: 0, name: 'Wil W'}
       *     bil: {count: 1, created: 199191911, 'Bil B'}
       *   }
       *
       * After 2nd message wil wrote bil and wil definitely read the message:
       *
       *   reduction = {
       *     wil: {count: 0, created: 0, name: 'Wil W'}
       *     bil: {count: 1, created: 12311319, name: 'Bil B'}
       *   }
       *
       *
       * @param {Object} reduction the user-name and counts thus far.
       * @param {Object} message a message object
       * @return {Object}  the user-names and unread count
       */
      return function (reduction, message) {
        if (!reduction[message.from_scmid.scmid]) {
          /*
            reduction {
              wil: {count: 0, created: 0}
            }
          */
          reduction[message.from_scmid.scmid] = {
            count: 0,
            created: 0,
            name: message.from_scmid.name
          };
        }

        /*
          reduction: {
            wil: {
              count: 3,
              created: 119292921
            }
          }
        */
        var unread = _messageUnreadByMoi(moi)(message);
        reduction[message.from_scmid.scmid].count += unread;

        if (message.created > reduction[message.from_scmid.scmid].created) {
          reduction[message.from_scmid.scmid].created = message.created;
        }

        Lazy(message.to_scmids).each(function (toScmid) {
          if (!reduction[toScmid.scmid]) {
            /*
              reduction {
                wil: {count: 3}
                bil: {count: 0}
              }
            */
            reduction[toScmid.scmid] = {
              count: 0,
              created: 0,
              name:  toScmid.name
            };
          }
        });

        return reduction;
      }; /* function */
    } /* _reduceByName */

    /**
     * Obtain a function that checks if moi has a read a single message.
     *
     * @param {string} moi the person presumably logged in.
     * @return {Function} the function
     */
    function _messageUnreadByMoi(moi) {
      /**
       * Test is moi has read the message yet.
       *
       * If the message was from moi then moi has definitely read the message.
       *
       * If the message is to moi then check the message.to_scmids.moi.status.
       *
       * @param {message} the message object
       * @return {integer} 1=moi has not read message yet, 0=moi has read
       */
      return function(message) {
        if (message.from_scmid.scmid === moi) {
          return 0;
        }

        return Lazy(message.to_scmids)
          .find(function (toScmid) {
            return ((toScmid.scmid === moi)
              && (toScmid.status < SCMSTAT.READ));
            }) ? 1:0;
      }; /* function */
    } /* _messageUnreadByMoi */

    /**
     * Turn {'wil@szeto.ca': [1,1,0,1]}
     * into {'wil@szeto.ca': {count: 3}}
     *
     * @param {integer} count the array of 1s and 0s
     * @param {string} name the scmid
     * @return {Object} a user-count ex. {name: 'wil@szeto.ca', count: 3}
     */
    function _mapCountToUser(counts, name) {
      var user = {};

      user[name] = {
        count: Lazy(counts).sum()
      };

      return user;
    }

    /**
     * Turn an array of messages into:
     *
     * <code><pre>
     *   [
     *      {name: 'wil@szeto.ca', count: 1, created: '1234567890'}
     *      {name: 'bil@szeto.ca', count: 20, created: '2345678901'}
     *      {name: 'gil@szeto.ca', count: 300, created: '3456789012'}
     *   ]
     * </pre></code>
     *
     *
     * First convert into somethign like this:
     *
     * <code><pre>
     *   {
     *      'wil@szeto.ca':  {count: 1, created: '1234567890'}
     *      'bil@szeto.ca':  {count: 20, created: '2345678901'}
     *      'gil@szeto.ca':  {count: 300, created: '3456789012'}
     *   }
     * </pre></code>
     *
     * And then into:
     *
     * <code><pre>
     *   [
     *      {name: 'wil@szeto.ca', count: 1, created: '1234567890'}
     *      {name: 'bil@szeto.ca', count: 20, created: '2345678901'}
     *      {name: 'gil@szeto.ca', count: 300, created: '3456789012'}
     *   ]
     * </pre></code>
     *
     * @param {Array} messages a list of messages
     * @return {Object} the unique users and the unread messages.
     */
    function messagesToBuddyDex(messages, moi) {
      //
      //   {
      //      'wil@szeto.ca':  {count: 1, created: '1234567890'}
      //      'bil@szeto.ca':  {count: 20, created: '2345678901'}
      //      'gil@szeto.ca':  {count: 300, created: '3456789012'}
      //   }
      //
      var userUnreadCreated = messagesToUserUnreadCreated(messages, moi);
      delete userUnreadCreated[moi];

      return Lazy(userUnreadCreated)
        .map(_remapToArray)
        .sortBy("created", true)
        .value();
    } /* messagesToBuddyDex */

    /**
     * Turn:
     *
     * {count: 1, created: '1234567890'}, 'wil'
     *
     * into:
     *
     * {scmid: 'wil', name: 'wil', count: 1, created: '1234567890'}
     *
     * @param {Object} unreadCreated an object containing count and created prop
     * @param {string} name the user-name
     */
    function _remapToArray(unreadCreated, scmid) {
      return Lazy({scmid: scmid}).assign(unreadCreated).value();
    }

    function messagesToFullBuddyDex(messages, moi) {
      var users = messagesToBuddyDex(messages, moi);
      return Lazy([{
          scmid: moi,
          name: moi,
          count: 0,
          created: 0
        }])
        .concat(users)
        .value();
    } /* messagesToFullBuddyDex */

    /**
     * Convert SCMAPI contacts to SCMW contacts.
     *
     * SCMAPI contacts:
     *
     *    [
     *       {
     *            "scmid": "bil@szeto.ca",
     *            "fullname": "Bil Bong"
     *       },
     *       {
     *            "scmid": "gil@szeto.ca",
     *            "fullname": "Gil Gong"
     *       },
     *       {
     *            "scmid": "wil@szeto.ca",
     *            "fullname": "Wil Wong"
     *       },
     *    ]
     *
     * SCMW contacts:
     *
     *    [
     *       {
     *            "scmid": "bil@szeto.ca",
     *            "name": "Bil Bong"
     *       },
     *       {
     *            "scmid": "gil@szeto.ca",
     *            "name": "Gil Gong"
     *       },
     *       {
     *            "scmid": "wil@szeto.ca",
     *            "name": "Wil Wong"
     *       },
     *    ]
     *
     * @param {Array} contacts the SCMAPI contacts
     * @return normalized scmw contacts
     */
    function reSerializeContacts(contacts) {
      return Lazy(contacts).map(function (contact) {
        var recontact = Lazy(contact)
          .assign({name: contact.fullname, curated: true})
          .value();
        delete recontact.fullname;
        return recontact;
      }).value();
    } /* reSerializeContacts */


    /**
     * Extract the scmids from the list of users.
     *
     * For example the 2 user list:
     *
     *    [
     *        {
     *            "scmid": "bil@szeto.ca",
     *            "name": "",
     *            "curated": true
     *        },
     *        {
     *            "scmid": "gil@szeto.ca",
     *            "name": "",
     *            "curated": true
     *        }
     *    ]
     *
     * get converted to:
     *
     * ['bil@szeto.ca', 'gil@szeto.ca']
     *
     * @param {Array} users a list of reserialized,scmw users
     * @return array of scmids
     */
    function remapUsersToScmids(users) {
      return Lazy(users).map(function (user) {
          return user.scmid;
        })
        .value();
    } /* remapUsersToScmids */
  } /* scmTr */
})();

(function () {
  angular
    .module('app')
    .factory('randomColour', randomColour);

  /**
   * The radomColour assigns a given string value, like a name, a randomly
   * generated rgb colour.
   *
   * Once a given string value has been assigned a colour randomColour will
   * consistently return the assigned colour.
   *
   */
  function randomColour() {
    var store = {};
    return _lookup;

    /**
     * Lookup or generate a colour for the given key.
     *
     * @param {String} key associate the colour with this name.
     */
    function _lookup(key) {
      if (store[key]) {
        return store[key];
      }

       store[key] = 'rgb(' + (Math.floor(Math.random() * 128) + 128) + ',' + (Math.floor(Math.random() * 128) + 128) + ',' + (Math.floor(Math.random() * 128) + 128) + ')';
       return store[key];
    } /* _lookup */
  } /*randomColour*/
})();

(function () {
  angular
    .module('app')
    .component('noteEditor', {
      templateUrl: 'app/note-editor.html',
      controller: NoteEditorController,
      bindings: {
        message: '<'
      }
    });

  NoteEditorController.$inject = ['$log', '$mdSidenav', '$state', 'scmService'];
  /**
   * NoteEditorController controls the note editing interface.
   *
   * @param {Object} $log the angular log provider
   * @param {Object} $mdSidenav the material sidenav provider
   * @param {Object} $state the ui-router state
   * @param {Object} scmService the scmw SCMAPI service
   */
  function NoteEditorController($log, $mdSidenav, $state, scmService) {
    var ctrl = this;

    ctrl.save = save;
    ctrl.cancel = cancel;
    ctrl.$onInit = _onInit;
    ctrl.$postLink = _postLink;

    /**
     * On the note-editor being initialized start the form off with the
     * current note body.
     *
     */
    function _onInit() {
      $log.debug("NoteEditorController", ctrl.message);
      ctrl.composition = ctrl.message.note.note || "";
    }

    /**
     * On the note-editor being compiled open up the right $mdSidenav.
     *
     * @param {Object} event some kind of event
     */
    function _postLink(event) {
      $log.debug("NoteEditorController._postLink...");
      $mdSidenav('right')
        .open()
        .then(function () {
          $log.debug("The right.note-editor is opened.");
        })
        .catch(function (error) {
          $log.error(error);
        });
    } /* _postLink */

    /**
     * Save what ever note the user presumably typed in and then close up the
     * right sidenav.
     *
     */
    function save() {
      if (ctrl.composition || ctrl.message.note.note) {
        scmService.addNote(ctrl.message.mid, ctrl.composition);
      }

      cancel();
    } /* save */

    /**
     * Cancel.  Close the right sidenav and load the app.index view.
     *
     */
    function cancel() {
      /* todo move this to a signal or into done() */
      $mdSidenav('right')
        .close()
        .then(function () {
          $state.go('app.index');
        });
    } /* cancel */

  }
})();

(function () {
  angular
    .module('app')
    .component('noEditor', {
      templateUrl: 'app/no-editor.html',
      controller: NoEditorController
    });

  NoEditorController.$inject = ['$log', '$mdSidenav'];
  /**
   * NoEditorController controls blank sidesav child.
   *
   * @param {Object} $log the angular log provider
   * @param {Object} $mdSidenav the material sidenav provider
   */
  function NoEditorController($log, $mdSidenav) {
    var ctrl = this;
    ctrl.$postLink = _postLink;

    /**
     * On the no-editor being compiled simply log a debug line.
     *
     * @param {Object} event some kind of event
     */
    function _postLink(event) {
      $log.debug("NoEditorController._postLink...");
    }
  } /* NoEditorController */
})();

(function () {
  angular
    .module('app')
    .component('miniSubmit', {
      templateUrl: 'app/mini-submit.html',
      controller: MiniSubmitController,
      bindings: {
        to: '<',
        name: '<'
      }
    });

  MiniSubmitController.$inject = ['scmService'];
  /**
   * MiniSubmitController controls the mini-submission interface.
   *
   * Attributes:
   *
   * @property {String} to  the scmid of the recipient
   * @property {String} name the real name of the recipient
   *
   */
  function MiniSubmitController(scmService) {
    var ctrl = this;

    ctrl.sendMessage = sendMessage;
    ctrl.composition = '';

    /**
     * Submit the typed message to SCMAPI and then reset the textarea.
     *
     */
    function sendMessage() {
      if (ctrl.composition) {
        scmService.submit([ctrl.to], ctrl.composition);
        ctrl.composition = '';
      }
    } /* sendMessage */
  }
})();

(function () {
  angular
    .module('app')
    .component('login', {
      templateUrl: 'app/login.html',
      controller: LoginController
    });

  LoginController.$inject = ['$log', '$stateParams', '$timeout', '__env',
    'scmService'];
  /**
   * The LoginController logs into SCMAPI and only logs into SCMAPI.
   *
   *
   *
   * @param {Object} $log the angular log object
   * @param {Object} $stateParams the ui-router parameters
   * @param {Object} $timeout the angular timeout provider
   * @param {Object} __env the global window environment
   * @param {Object} scmService the scmw SCMAPI service
   */
  function LoginController($log, $stateParams, $timeout, __env, scmService) {
    var ctrl = this;

    ctrl.login = login;
    ctrl.title = __env.title || '';
    ctrl.fontFamily = __env.fontFamily || 'inherit';
    ctrl.fontUrl = __env.fontUrl || '';
    ctrl.username = (__env.enableDebug) ? 'wil@szeto.ca' : '';
    ctrl.password = (__env.enableDebug) ? '1234' : '';
    ctrl.error = $stateParams.error || "";
    ctrl.googlePlayUrl = __env.googlePlayUrl || '';
    ctrl.appStoreUrl = __env.appStoreUrl || '';

    /**
     * Login.
     *
     * Submit the login information to the SCMAPI.
     *
     */
    function login() {
      scmService.signin(ctrl.username, ctrl.password)
        .then(function (result) {
          $log.debug(JSON.stringify(result));
        })
        .catch(function (error) {
          $log.debug(JSON.stringify(error));
          ctrl.password = "";
          ctrl.error = error;
        });

      return;
    } /* login */
  } /* LoginController */
})();

(function () {
  angular
    .module('app')
    .filter('lastToOrFrom', lastToOrFromFilter);

  lastToOrFromFilter.$inject = ['$log'];
  /**
   * Obtain the lastToOrFrom filter.
   *
   * @param {Object} $log the angular $log service
   * @return {Function} the filter
   */
  function lastToOrFromFilter($log) {
    return getLastToOrFrom;

    /**
     * Get the last message to or from toi.
     *
     * @param {Array} messages a list of messages
     * @param {string} toi the person writing moi the message
     * @return {Object}  the matching message, undefined if not found
     */
    function getLastToOrFrom(messages, toi) {
      var last = Lazy(messages)
        .filter(function (message) {
          if (toi === message.from_scmid.scmid) {
            return true;
          }

          return Lazy(message.to_scmids)
            .find(function (toScmid) {
              return (toScmid.scmid === toi);
            });
        })
        .last();

      $log.debug("Found last to or from", toi, last);
      return last;
    } /* getLastToOrFrom */

  } /* lastToOrFromFilter */
})();

(function () {
  angular
    .module('app')
    .filter('lastForMe', lastForMeFilter);

  lastForMeFilter.$inject = ['$log'];
  /**
   * Obtain the lastForMe filter.
   *
   * @param {Object} $log the angular $log service
   * @return {Function} the filter
   */
  function lastForMeFilter($log) {
    return getLastForMe;

    /**
     * Get the last message for moi and from toi.
     *
     * If moi and toi are equal then the toi condition is ignored and this
     * function returns last message for moi.
     *
     * @param {Array} messages a list of messages
     * @param {string} moi the person logged in
     * @param {string} toi the person writing moi the message
     * @return {Object}  the matching message, undefined if not found
     */
    function getLastForMe(messages, moi, toi) {
      var last = Lazy(messages)
        .filter(function (message) {
          return ((toi === moi)
            || (toi === message.from_scmid.scmid))
        })
        .filter(function (message) {
          return Lazy(message.to_scmids)
            .find(function (toScmid) {
              return (toScmid.scmid === moi);
            });
        })
        .last();

      $log.debug("Found last", last);
      return last;
    } /* getLastForMe */
  } /* lastToOrFromFilter */
})();

(function () {
  angular
    .module('app')
    .filter('intervalAgo', intervalAgoFilter);

  /**
   * Obtain an intervalAgoFilter.
   *
   */
  function intervalAgoFilter() {
    /**
     * Obtain the approximate time ago given a fixed unixtime.
     *
     * Example:
     *
     *   "2s"
     *   "10m"
     *   "4h"
     *   "1d"
     *
     * @param {integer} unixtime
     * @return {string} how much time ago
     */
    return function (unixtime) {
      if (0 >= unixtime) {
        return "";
      }

      var nowDate = new Date();
      interval = Math.round(nowDate.getTime()/1000 - unixtime);
      if (0 >= interval) {
        return "";
      }

      if (60 > interval) {
        return interval + "s";
      } else if (3600 > interval) {
        return Math.round(interval/60) + "m";
      } else if (86400 > interval) {
        return Math.round(interval/3600) + "h";
      } else {
        return Math.round(interval/86400) + "d";
      }
    }
  } /* lastMessagePerUserFilter */
})();

(function () {
  angular
    .module('app')
    .filter('initials', initialsFilter);

  /**
   * Obtain a function that extracts the initials of a name or user-name or
   * some other token.
   *
   *
   */
  function initialsFilter() {
    /**
     * Obtain the initials from a given string.
     *
     * For example:
     *
     *    "Disco Stu" -> "DS"
     *    "Mr. Burns" -> "B"
     *    "Homer.J.Simpson" -> "HS"
     *
     *
     * @param {string} fullName the full-name or user-name or some other token
     * @return {string} the initials
     */
    return function (fullName) {
      var tokens;

      if (!fullName) {
        return '';
      }

      /* Strip the Dr. or Mr. or Mrs. */
      fullName = fullName.replace(/^dr[.]+\s*|^mr[.]+\s*|^mrs[.]+\s*|^ms[.]+\s*/i, '');

      /* If fullName is all numeric then return the last 2 digits. */
      if (/^[\d\-.\s]+$/.test(fullName)) {
        return fullName.substr(fullName.length - 2);
      }

      /* Assume it is a name, like Homer Simpson or Homer J. Simpson */
      tokens = fullName.split(/[^\w]/);

      /* If there is just one token take the 1st */
      if (1 >= tokens.length) {

        return tokens[0][0].toUpperCase();
      }

      /* If there are exactly 3 tokens then assume "Homer J Simpons" */
      if (3 === tokens.length) {
        return tokens[0][0].toUpperCase() + tokens[2][0].toUpperCase();
      }

      /* Just take the 1st and 2nd tokens */
      return tokens[0][0].toUpperCase() + tokens[1][0].toUpperCase();
    };
  } /* initialsFilter */
})();

(function () {
  angular
    .module('app')
    .component('initialOn', {
      templateUrl: 'app/initial-on.html',
      controller: InitialOnController,
      bindings: {
        name: '<',
        uid: '<'
      }
    });

  InitialOnController.$inject = ['$log', '$element', 'randomColour'];
  /**
   * The InitialOnController controls the iniitalOn component,
   * a circle with someone's initials, like HS for Homer Simpson.
   *
   *    Initials + Icon = initial-on
   *
   * Attributes:
   *
   * @property {String} name the real name
   * @property {String} uid the user-name/scmid/id
   *
   *
   * @param {Object} $log the angular log object
   */
  function InitialOnController($log, $element, randomColour) {
    var ctrl = this;

    ctrl.$postLink = _postLink;

    /**
     * Set the background-color once the DOM has been linked.
     *
     * Reminder:
     *
     *    $element = <initial-on>
     *    $element.find("div") = 1st div
     *
     */
    function _postLink() {
      $element.find("md-whiteframe").css("background-color", randomColour(ctrl.uid));
    } /* _postLink */
  } /* InitialOnController */
})();

(function () {
  angular
    .module('app')
    .component('fullComposeEditor', {
      templateUrl: 'app/full-compose-editor.html',
      controller: FullComposeEditorController,
      bindings: {
        contacts: '<'
      }
    });

  FullComposeEditorController.$inject = ['$log', '$mdSidenav', '$state',
    'scmService', 'scmTr'];
  /**
   * FullComposeEditorController controls the note editing interface.
   *
   * Attributes:
   *
   * @property {Array} contacts an array of scmw/reserialized users
   *
   *
   * @param {Object} $log the angular log provider
   * @param {Object} $mdSidenav the material sidenav provider
   * @param {Object} $state the ui-router state
   * @param {Object} scmService the scmw SCMAPI service
   */
  function FullComposeEditorController($log, $mdSidenav, $state, scmService,
    scmTr) {
    var ctrl = this;

    ctrl.tos = [];
    ctrl.composition = "";

    ctrl.send = send;
    ctrl.cancel = cancel;
    ctrl.$onInit = _onInit;
    ctrl.$postLink = _postLink;

    /**
     * On the full-compose-editor being initialized start the form off with the
     * current note body.
     *
     */
    function _onInit() {
      $log.debug("FullComposeEditorController", ctrl.contacts);
      ctrl.composition = "";
    }

    /**
     * On the full-compose-editor being compiled open up the right $mdSidenav.
     *
     * @param {Object} event some kind of event
     */
    function _postLink(event) {
      $log.debug("FullComposeEditorController._postLink...");
      $mdSidenav('right')
        .open()
        .then(function () {
          $log.debug("The right.full-compose-editor is opened.");
        })
        .catch(function (error) {
          $log.error(error);
        });
    } /* _postLink */

    /**
     * Save what ever note the user presumably typed in and then close up the
     * right sidenav.
     *
     */
    function send() {
      $log.debug("full-componse-editor.send", ctrl.tos, ctrl.composition);
      if (!ctrl.composition) {
        return;
      }
      var tos = scmTr.remapUsersToScmids(ctrl.tos);
      $log.debug("full-componse-editor.send", tos);
      if (!tos || 0 >=tos.length) {
        return;
      }

      scmService.submit(tos, ctrl.composition);
      cancel();
    } /* send */

    /**
     * Cancel.  Close the right sidenav and load the app.index view.
     *
     */
    function cancel() {
      /* todo move this to a signal or into done() */
      $mdSidenav('right')
        .close()
        .then(function () {
          $state.go('app.index');
        });
    } /* cancel */

  }
})();

(function () {
  angular
    .module('app')
    .controller('FullComposeDialogController', FullComposeDialogController);

  FullComposeDialogController.$inject = ['$log', '$mdDialog', '$scope',
    'scmService', 'scmTr', 'contacts'];
  /**
   * The FullComposeDialogController controls full-compose-dialog.
   *
   * Pass the users parameter using $mdDialog.show.locals.
   *
   * @param {Object} $log the angular log object
   * @param {Object} $mdDialog the dialog provider
   * @param {Object} $scope the current scope
   * @param {Object} scmService the SCMAPI service
   * @param {Object} scmTr the SCM transform service
   * @param {string} contacts a list of scmw users 
   */
  function FullComposeDialogController($log, $mdDialog, $scope, scmService,
    scmTr, contacts) {
    var ctrl = this;

    ctrl.closeDialog = closeDialog;
    ctrl.sendMessage = sendMessage;
    ctrl.contacts = contacts || [];
    ctrl.tos = [];
    ctrl.composition = "";

    /**
     * Just cancel the dialog.
     *
     *
     *
     */
    function closeDialog() {
      $mdDialog.cancel();
    }

    /**
     * Submit a message to SCMAPI and then close the window.
     *
     *
     *
     */
    function sendMessage() {
      $log.debug(ctrl.tos, ctrl.composition);
      if (!ctrl.composition) {
        return;
      }
      var tos = scmTr.remapUsersToScmids(ctrl.tos);
      $log.debug(tos);
      if (!tos || 0 >=tos.length) {
        return;
      }

      scmService.submit(tos, ctrl.composition);
      $mdDialog.hide();
    }
  }
})();

(function () {
  angular
    .module('app')
    .filter('firstUnread', firstUnreadFilter);

  firstUnreadFilter.$inject = ['$log', 'SCMSTAT'];
  /**
   * Obtain the firstUnread filter.
   *
   * @param {Object} $log the angular log service
   * @param {Object} SCMSTAT the scm constants
   * @return {Function} the filter
   */
  function firstUnreadFilter($log, SCMSTAT) {
    /**
     * Obtain the 1st UNREAD inbound message from toi to moi.
     *
     * If moi is toi then toi will be essentially ignored making the result
     * any message for moi that is unread.
     *
     * @param {Array} messages a list of messages
     * @param {string} moi the person logged in
     * @param {string} toi the person writing moi the message
     * @return {Object}  the matching message, undefined if not found
     */
    return function(messages, moi, toi) {
      var first = Lazy(messages)
        .filter(function (message) {
          return ((toi === moi)
            || (toi === message.from_scmid.scmid))
        })
        .filter(function (message) {
          return Lazy(message.to_scmids)
            .find(function (toScmid) {
              return ((toScmid.scmid === moi)
                && (toScmid.status < SCMSTAT.READ));
            });
        })
        .first();

      if (first) {
        $log.debug("firstUnread:", first);
      }
      return first;
    } /* function */
  } /* firstUnreadFilter */
})();

(function () {
  angular
    .module('app')
    .component('conversationThread', {
      templateUrl: 'app/conversation-thread.html',
      controller: ConversationThreadController,
      bindings: {
        messages: '<',
        moi: '<',
        toi: '<'
      }
    });

  ConversationThreadController.$inject = ['$anchorScroll', '$location', '$log',
    '$scope', '$timeout', 'firstUnreadFilter', 'lastToOrFromFilter',
    'tailFilter'];
  /**
   * The ConversationThreadController controls the list of messages
   * representing a single conversation.
   *
   * Attibutes:
   *
   * @property {Array} messages an array of messages
   * @property {String} moi the scmid of the person staring at the app
   * @property {String} toi the "other" guy in the conversation, can be moi
   *
   *
   *
   * @param {Object} $anchorScroll the angular scroll provider
   * @param {Object} $location the angular location provider
   * @param {Object} $log the angular log object
   * @param {Object} $scope the conversation-thread angular scope
   * @param {Object} $timeout the angular timeout provider
   * @param {Function} firstUnreadFilter the 1st unread filter
   * @param {Function} lastToOrFromFilter the last-to-or-from filter
   * @param {Function} tailFilter the last item filter
   */
  function ConversationThreadController($anchorScroll, $location, $log, $scope,
    $timeout, firstUnreadFilter, lastToOrFromFilter, tailFilter) {
    var ctrl = this;

    ctrl.$onChanges = _onChanges;
    ctrl.scrollTo = 0;

    /**
     * $onChanges did not detect changes to the messages array so I watch the
     * array here using $watchCollection.
     *
     * On the messages changing...
     *
     * Scroll to the best spot.
     *
     */
    $scope.$watchCollection(angular.bind(ctrl, function () {
      return ctrl.messages;
    }), function (newVal, oldVal) {
      _scrollTo();
    });

    /**
     * On the toi changing scroll to the best spot.
     *
     *
     *
     */
    function _onChanges(changeObj) {
      if (changeObj.toi) {
        _scrollTo();
      }
    }

    /**
     * Find the best spot to scrollTo then actually scroll there.
     *
     * The best spot could be the first unread, inbound message or could it be
     * the last inbound message or it could be just the last message.
     */
    function _scrollTo() {
      var message = firstUnreadFilter(ctrl.messages, ctrl.moi, ctrl.toi)
        || lastToOrFromFilter(ctrl.messages, ctrl.toi)
        || tailFilter(ctrl.messages);
      ctrl.scrollTo = (message) ? message.mid : 0;

      $log.debug("ConversationThreadController scrollTo to", ctrl.scrollTo);
      $timeout(function () {
        $log.debug("Scroll to", ctrl.scrollTo);
        $location.hash('mid-' + ctrl.scrollTo);
        $anchorScroll();
      }, 250);
    }
  }
})();

(function () {
  angular
    .module('app')
    .component('contactWhom', {
      templateUrl: 'app/contact-whom.html',
      controller: ContactWhomController,
      bindings: {
        contacts: '<',
        tos: '='
      }
    });

  ContactWhomController.$inject = ['$log', 'whominFilter'];
  /**
   * The ContactWhomController controls the interface allowing the user to pick
   * recipients.
   *
   * Attributes:
   *
   * @property {Array} contacts a list of reserialized/scmw users
   * @property {Array} tos the recipient scmw users
   *
   * @param {Object} $log the angular log
   * @param {Object} whominFilter the whomin filter service
   */
  function ContactWhomController($log, whominFilter) {
    var ctrl = this;

    ctrl.transformChip = transformChip;
    ctrl.querySearch = querySearch;

    /**
     * Transform any partial strings into chips.
     *
     * Intended use as md-transform-chip.
     *
     * @param {String|Object} chip the
     * @return a scmw user object
     */
    function transformChip(chip) {
      $log.debug("ContactWhom.transformChip", chip);
      /* If it is an object, it's already a known chip */
      if (angular.isObject(chip)) {
        return chip;
      }

      /* Otherwise, create a new one */
      return { scmid: chip };
    } /* transformChip */

    /**
     * Obtain a list of user-objects matching the query text.
     *
     *
     * @param {string} query what the user entered so far
     * @return {Array} an array of scmw/reserialized user objects.
     */
    function querySearch(query) {
      $log.debug("Hunting for a user matching:", query);
      return whominFilter(ctrl.contacts, query);
    } /* querySearch */
  } /* ContactWhomController */
})();

(function () {
  angular
    .module('app')
    .run(registerCancelDialogHandlers);

  registerCancelDialogHandlers.$inject = ['$mdDialog', '$rootScope'];
  /**
   * Register event handlers for ui-router state changes.
   *
   *
   */
  function registerCancelDialogHandlers($mdDialog, $rootScope) {
    /**
     * Cancel all dialogs on ui-router state changes.
     *
     * Avoid stale dialog windows.
     *
     *
     */
    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams,
      fromState, fromParams) {
      $mdDialog.cancel();
    });
  } /* registerCancelDialogHandlers */
})();

(function () {
  angular
    .module('app')
    .component('buddyDex', {
      templateUrl: 'app/buddy-dex.html',
      controller: BuddyDexController,
      bindings: {
        messages: '<',
        moi: '<',
        selected: '<',
        listToggled: '&',
        userSelected: '&'
      }
    });

  BuddyDexController.$inject = ['$log', '$mdDialog', '$mdSidenav', '$scope',
    '$state', '$timeout', 'scmService', 'scmTr'];
  /**
   * The BuddyDexController controls the buddyDex component,
   * a list of people whom the web-user has correspondence.
   *
   * The buddy-dex is an index of the user's with correspondence
   * and should not be confused with a contact list of buddy list.
   *
   * Attributes:
   *
   * @property {Array} messages a list of messages
   * @property {String} moi the scmid of the human person staring at the app
   * @property {Object} selected the selected conversation user
   * @property {Function} listToggled open/close the left sidebar callback
   * @property {Function} userSelected the user selected callback
   *
   *
   *
   * @param {Object} $log the angular log object
   * @param {Object} $mdDialog angular-material dialog provider
   * @param {Object} $mdSidenav angular-material sidenav provider
   * @param {Object} $scope the buddy-dex angular scope
   * @param {Object} $state the ui-router state
   * @param {Object} $timeout the angular timeout provider
   * @param {Object} scmTr the scmw transform service
   */
  function BuddyDexController($log, $mdDialog, $mdSidenav, $scope, $state,
    $timeout, scmService, scmTr) {
    var ctrl = this;

    ctrl.toggleList = toggleList;
    ctrl.selectUser = selectUser;
    ctrl.fullComposeClick = fullComposeClick;
    ctrl.$onDestroy = _onDestroy;
    ctrl.users = [];


    /**
     * On clicking anywhere inside the list of users...
     *
     * Call the listToggled callback.
     *
     */
    function toggleList() {
      ctrl.listToggled();
    }

    /**
     * On clicking any of the individual items...
     *
     * Call the onSelectedUser callback.
     *
     * @param user the user object
     */
    function selectUser(user) {
      ctrl.userSelected({user: user});
    }

    /**
     * On clicking the full-compose-button launch the the full-compose-dialog.
     *
     * Also close the sidenav.
     *
     * @param {Object} event the angular event
     */
    function fullComposeClick(event) {
      /* _showDialog(event); */
      _showRightSidenav(event);
      $mdSidenav('left').close();
    }

    /**
     * Open up the right sidenav.
     *
     * Set the state.
     *
     * @param {Object} event the angular event
     */
    function _showRightSidenav(event) {
      $state.go('app.full-compose-editor', {correspondents: ctrl.users});
    }

    /**
     * Show the full-compose-dialog dialog.
     *
     * @param {Object} event the click event
     * @return {Promise} a dialog promise.
     */
    function _showDialog(event) {
      return scmService.fuseContacts(ctrl.users)
        .then(function (contacts) {
          var locals = {contacts: contacts};
          return $mdDialog.show({
            templateUrl: 'app/full-compose-dialog.html',
            controller: "FullComposeDialogController",
            controllerAs: "$ctrl",
            locals: locals,
            // parent: event.target,
            targetEvent: event,
            clickOutsideToClose: true,
            fullscreen: false
          });
        })
        .catch(function (error) {
          $log.error(error);
        });
    } /* showDialog */

    /**
     * $onChanges did not detect changes to the messages array so I watch the
     * array here using $watch.  And I $watch deeply! Ouch.
     *
     * On the messages changing...
     *
     * Refresh the buddy-dex.
     *
     *
     */
    $scope.$watch(angular.bind(ctrl, function () {
      return ctrl.messages;
    }), function (newVal, oldVal) {
      $log.debug("buddy-dex watch (deep watch)");
      _refreshBuddyDex();
      $log.debug("buddy-dex", ctrl.users);
    }, true);

    /**
     * Recalculate the user/count/created model.
     *
     * Redo the entire buddy-dex.
     *
     * If the user has not selected any user yet then call the onSelectUser
     * callback with the 1st user (which is always moi).
     *
     */
    function _refreshBuddyDex() {
      /* Create the intermediary name/count/create */
      $log.debug("buddy-dex refresh");
      ctrl.users = scmTr.messagesToFullBuddyDex(ctrl.messages, ctrl.moi);

      /* No one is selected on first run so select one. */
      if (!ctrl.selected) {
        ctrl.userSelected({user: ctrl.users[0]});
      }
    } /* _refreshBuddyDex */

    /**
     * The buddy-dex says "10s ago" so refresh the "10s ago" to be
     * "1m ago".
     *
     */
    function _refreshOverAndOver() {
      _refreshBuddyDex();
      ctrl.overAndOver = $timeout(_refreshOverAndOver, 60000);
    } /* _refreshOverAndOver */

    ctrl.overAndOver = $timeout(_refreshOverAndOver, 60000);

    /**
     * On the component's destruction...
     *
     * Cancel the _refreshOverAndOver.
     *
     */
    function _onDestroy() {
      $timeout.cancel(ctrl.overAndOver);
    }
  } /* BuddyDexController */
})();

(function () {
  angular
    .module('app')
    .component('blurb', {
      templateUrl: 'app/blurb.html',
      controller: BlurbController,
      bindings: {
        message: '<',
        moi: '<',
        toi: '<'
      }
    });

  BlurbController.$inject = ['$log', '$mdDialog', '$scope', '$state', 'SCMSTAT',
    'scmService'];
  /**
   * The BlurbController controlls the blurb, a single unit that together with
   * other blurbs form a conversation.
   *
   * @param {Object} $log the angular $log service
   * @param {Object} $mdDialog the material dialog service
   * @param {Object} $scope the angular $scope
   * @param {Object} SCMSTAT the SCM connstants
   * @param {Object} scmService the SCMAPI service 
   */
  function BlurbController($log, $mdDialog, $scope, $state, SCMSTAT,
    scmService) {
    var ctrl = this;

    ctrl.buttonClicked = buttonClicked;
    ctrl.editNote = editNote;
    $scope.SCMSTAT = SCMSTAT;

    /**
     * Add/edit note.
     *
     * Change the state to app.note-editor.
     *
     */
    function editNote() {
      $log.debug("Go to app.note-editor.");
      $state.go("app.note-editor", {message: ctrl.message});
    }

    /**
     * On clicking the per-blurb action button.
     *
     * Ask SCMAPI to change the message status.
     *
     * @param {Object} event the angular $event
     * @param {string} the currrent status
     */
    function buttonClicked(event, currentStatus) {
      $log.debug("Blurb action btn clicked", ctrl.message.mid, currentStatus);
      if (SCMSTAT.NEW === currentStatus) {
        scmService.markMessagesDelivered([ctrl.message.mid]);
      } else if (SCMSTAT.DELIVERED === currentStatus) {
        scmService.markMessagesRead([ctrl.message.mid]);
      } else if (SCMSTAT.READ === currentStatus) {
        _showDialog(event)
          .then(function (answer) {
            if ('delete' === answer) {
              scmService.deleteMessages([ctrl.message.mid]);
            }
          })
          .catch(function () {
            $log.debug('You cancelled the dialog.');
          });
      } else if (SCMSTAT.DELETED === currentStatus) {
        /* SCMAPI responds accpeted=true when marking a deleted message read
         * but the message does not come back from being deleted.
         */
        // scmService.markMessagesRead([ctrl.message.mid]);
      }
    } /* buttonClicked */

    /**
     * Show the are-you-sure dialog.
     *
     * @param {Object} event the angular click $event
     * @return {Promise} a dialog promise.
     */
    function _showDialog(event) {
      var locals = {message: ctrl.message};
      var elid = 'mid-' + ctrl.message.mid;
      var el = angular.element(document.getElementById(elid));

      return $mdDialog
        .show({
        templateUrl: 'app/blurb-action.html',
        controller: "BlurbActionController",
        controllerAs: "$ctrl",
        locals: locals,
        parent: el,
        targetEvent: event,
        clickOutsideToClose: true,
        fullscreen: false,
        openFrom: event.target,
        closeTo: event.target
      });
    } /* showDialog */
  } /* BlurbController */
})();

(function () {
  angular
    .module('app')
    .controller('BlurbActionController', BlurbActionController);

  BlurbActionController.$inject = ['$mdDialog', 'message'];
  /**
   * The BlurbActionController controls the blurb action dialog.
   *
   * Pass the message parameter using $mdDialog.show.locals.
   *
   * @param {Object} $mdDialog the dialog provider
   * @param {string} message the message about to be deleted
   */
  function BlurbActionController($mdDialog, message) {
    var ctrl = this;

    ctrl.answer = answer;
    ctrl.cancel = cancel;
    ctrl.message = message;


    function answer(answer) {
      $mdDialog.hide(answer);
    }

    function cancel() {
      $mdDialog.cancel();
    }
  }
})();

(function () {
  angular
    .module('app')
    .run(registerAuthHandlers);


  registerAuthHandlers.$inject = ['$rootScope', '$state'];
  /**
   * Registerer "scm:authentication" event handlers.
   *
   * @param {Object} $rootScope the angular root scope
   * @param {Object} $state the ui-router $state
   */
  function registerAuthHandlers($rootScope, $state) {
    /**
     * Listen for "scm:authentication" signals and adjust the ui-router states
     * according to the supplied options.
     *
     * If there was an error then go to the "login" state.
     *
     * If there was a success then go to the "app" state.
     *
     * @param {Object} event some kind of event angular jams in
     * @param {Object} opt the {error: error} or {}
     */
    $rootScope.$on('scm:authentication', function (event, opt) {
      if (angular.isDefined(opt.error)) {
        $state.go("login", {error: opt.error});
      } else {
        $state.go("app.index");
      }
    });
  } /* registerAuthHandlers */
})();

(function () {
  angular
    .module('app')
    .component('app', {
      templateUrl: 'app/app.html',
      controller: AppController
    });

  AppController.$inject = ['$log', '$mdSidenav', '$scope', '$state',
    'scmService'];
  /**
   * The AppController controls <app></app>.
   *
   * The AppController coordinates with other components.
   *
   * @param {Object} $log the angular log object
   * @param {Object} $mdSidenav angular-material sidenav service
   * @param {Object} $scope the app scope
   * @param {Object} $state the ui-router state
   * @param {Object} scmService the scmw SCMAPI service
   * @return {Object} the app controller
   */
  function AppController($log, $mdSidenav, $scope, $state, scmService) {
    var ctrl = this;

    ctrl.onListToggled = onListToggled;
    ctrl.onUserSelected = onUserSelected;
    ctrl.logout = logout;
    ctrl.account = account;
    ctrl.moi = scmService.moi() || 'wil@szeto.ca';
    ctrl.toiUser = undefined;
    ctrl.loadingMessagesMessage = "Loading messages. This might take awhile."

    scmService.loadAllMessages()
      .then(function (messages) {
        ctrl.messages = messages;
      })
      .finally(function () {
        ctrl.loadingMessagesMessage = undefined;
      });

    /**
     * Hide or Show the 'left' sideNav area.
     *
     */
    function onListToggled() {
      $mdSidenav('left').toggle();
    }

    /**
     * Save the selected user.
     *
     * @param user the name and count
     */
    function onUserSelected(user) {
      $log.debug("AppController:onUserSelected", user);
      ctrl.toiUser = user;
    }

    /**
     * On clicking the logout button...
     *
     * Emit an event representing a deliberate logout.
     *
     */
    function logout() {
      scmService.signout('Logout');
    }

    /**
     * Go to the account settings view.
     *
     */
    function account() {
      $log.debug("Go to app.account.");
      $state.go("account");
    }
  }
})();

(function () {
  angular
    .module('app')
    .component('accountSettings', {
      templateUrl: 'app/account-settings.html',
      controller: AccountSettingsController,
      bindings: {
      }
    });

  AccountSettingsController.$inject = ['$log', '$mdDialog', '$state',
    'scmService'];
  /**
   * AccountEditorController controls the account settings interface.
   *
   * The account settings include:
   *
   * 1. Changing the password
   *
   * @param {Object} $log the angular log provider
   * @param {Object} $mdDialog the material dialog provider
   * @param {Object} $state the ui-router state
   * @param {Object} scmService the scmw SCMAPI service
   */
  function AccountSettingsController($log, $mdDialog, $state, scmService) {
    var ctrl = this;

    ctrl.password = null;
    ctrl.newPassword = null;
    ctrl.confirmPassword = null;

    ctrl.changePassword = changePassword;
    ctrl.comparePassword = comparePassword;
    ctrl.back = back;
    ctrl.passwordRegex = "[a-zA-Z0-9]+";

    /**
     * Go back to the main app.
     *
     *
     */
    function back() {
      $state.go('app.index');
    } /* back */

    /**
     * Submit the password change to the SCMAPI server, clear the form and
     * finally display the success/failure of the change.
     *
     * @param {Object} event the javascript event
     */
    function changePassword(event) {
      $log.debug("changePassword()", ctrl.password, ctrl.newPassword);
      scmService.changePassword(ctrl.password, ctrl.newPassword)
        .then(function (accepted) {
          $log.debug(accepted);

          ctrl.password = null;
          ctrl.newPassword = null;
          ctrl.confirmPassword = null;

          $log.debug(ctrl.passwordForm);
          ctrl.passwordForm.$setPristine();
          ctrl.passwordForm.$setUntouched();
          $log.debug(ctrl.passwordForm);

          $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(
                document.querySelector('#changePassword')))
              .clickOutsideToClose(true)
              .title('Change Password')
              .textContent('Password changed!')
              .ariaLabel('Password changed!')
              .ok('OK')
              .targetEvent(event)
            );
        })
        .catch(function (error) {
          $log.error(error);

          error = error || '';

          $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(
                document.querySelector('#changePassword')))
              .clickOutsideToClose(true)
              .title('Change Password FAILED')
              .textContent(error)
              .ariaLabel('Password failed! ' + error)
              .ok('OK')
              .targetEvent(event)
            );
        });
    } /* changePassword */

    /**
     * Check if the new-password matches the confirm-password.
     *
     * comparePassword() is expected to be called on ng-keyup.
     *
     * If there is a mismatch then set the confirmPassword form field as being
     * invalid.
     */
    function comparePassword() {
      ctrl.passwordForm.confirmPassword
        .$setValidity('matchPassword',
                      (ctrl.newPassword === ctrl.confirmPassword));
    } /* comparePassword */
  } /* AccountSettingsController */
})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/account-settings.html","<md-toolbar layout=\"row\">\n  <md-button ng-click=\"$ctrl.back()\" aria-label=\"Go Back\">\n    <md-icon md-svg-icon=\"arrow-left\"></md-icon>\n  </md-button>\n  <span flex></span>\n  <h1 class=\"md-toolbar-tools\">Account</h1>\n  <span flex></span>\n</md-toolbar>\n<md-content layout-padding=\"\" flex>\n  <div>\n    <!-- Change Password -->\n    <md-whiteframe class=\"md-whiteframe-z1\" layout=\"column\" layout-align=\"start start\">\n      <md-toolbar class=\"md-hue-1\" layout-padding layout=\"row\" layout-align=\"start center\">Password</md-toolbar>\n      <div id=\"changePassword\" class=\"dummy-div-for-ie\" layout-padding>\n        <form name=\"$ctrl.passwordForm\" flex layout=\"column\">\n          <md-input-container class=\"md-icon-float\">\n            <label>Current Password</label>\n            <input type=\"password\" name=\"password\" ng-model=\"$ctrl.password\" verify-password required>\n            <div ng-messages=\"$ctrl.passwordForm.password.$error\">\n              <ng-message when=\"required\">Enter current password.</ng-message>\n              <ng-message when=\"verifyPassword\">Unauthorized.</ng-message>\n            </div>\n          </md-input-container>\n          <p>\n            Passwords may contain letters and numbers (no punctuation, nor whitespace).\n          </p>\n          <md-input-container class=\"md-icon-float\">\n            <label>New Password</label>\n            <input type=\"password\" name=\"newPassword\" ng-keyup=\"$ctrl.comparePassword()\" ng-model=\"$ctrl.newPassword\" ng-pattern=\"$ctrl.passwordRegex\" minlength=\"4\" required>\n            <div ng-messages=\"$ctrl.passwordForm.newPassword.$error\">\n              <ng-message when=\"required\">Supply a new password.</ng-message>\n              <ng-message when=\"pattern\">Only letters and numbers are allowed</ng-message>\n              <ng-message when=\"minlength\">4 character minimum</ng-message>\n            </div>\n          </md-input-container>\n          <md-input-container class=\"md-icon-float\">\n            <label>Confirm Password</label>\n            <input type=\"password\" name=\"confirmPassword\" ng-keyup=\"$ctrl.comparePassword()\" ng-model=\"$ctrl.confirmPassword\" ng-pattern=\"$ctrl.passwordRegex\" minlength=\"4\" required>\n            <div ng-messages=\"$ctrl.passwordForm.confirmPassword.$error\">\n              <ng-message when=\"required\">Confirm password.</ng-message>\n              <ng-message when=\"matchPassword\">The password do not match.</ng-message>\n            </div>\n          </md-input-container>\n        </form>\n        <md-button class=\"md-raised md-accent\" ng-click=\"$ctrl.changePassword($event)\" ng-disabled=\"$ctrl.passwordForm.$invalid\">\n          Change Password\n        </md-button>\n      </div>\n    </md-whiteframe>\n  </div>\n</md-content>\n");
$templateCache.put("app/app.html","<div class=\"app\" layout=\"column\" flex>\n  <md-toolbar layout=\"row\">\n    <md-button ng-click=\"$ctrl.onListToggled()\" aria-label=\"Toggle users list\" hide-gt-sm>\n      <md-icon md-svg-icon=\"account-multiple\"></md-icon>\n    </md-button>\n    <span flex></span>\n    <div layout=\"column\" layout-align=\"center center\">\n      <span class=\"title\">{{$ctrl.toiUser.name || $ctrl.toiUser.scmid}}</span>\n    </div>\n    <span flex></span>\n\n    <md-menu md-position-mode=\"target-right target\">\n      <md-button aria-label=\"Open more menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n        <md-icon md-menu-origin md-svg-icon=\"dots-vertical\"></md-icon>\n      </md-button>\n      <md-menu-content width=\"4\">\n        <md-menu-item>\n          <md-button ng-click=\"$ctrl.account()\" aria-label=\"My Account\">\n            <div layout=\"row\">\n              <div flex>{{$ctrl.moi}}</div>\n              <md-icon md-svg-icon=\"account\"></md-icon>\n            </div>\n          </md-button>\n        </md-menu-item>\n        <md-menu-item>\n          <md-button ng-click=\"$ctrl.logout()\" aria-label=\"Logout\">\n            <div layout=\"row\">\n              <div flex>Logout</div>\n              <md-icon md-svg-icon=\"logout\"></md-icon>\n            </div>\n          </md-button>\n        </md-menu-item>\n      </md-menu-content>\n    </md-menu>\n  </md-toolbar>\n\n  <!-- loading messages message -->\n  <div ng-if=\"$ctrl.loadingMessagesMessage\" layout=\"column\" layout-align=\"center center\" flex>\n    <md-progress-linear md-mode=\"query\" ng-disabled=\"!$ctrl.loadingMessagesMessage\">\n    </md-progress-linear>\n    <span>{{$ctrl.loadingMessagesMessage}}</span>\n  </div>\n\n  <!-- the interesting parts of the app -->\n  <div class=\"container\" ng-if=\"!$ctrl.loadingMessagesMessage\" layout=\"row\" flex>\n    <!-- left side nav -->\n    <md-sidenav md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"left\" layout=\"column\" layout=\"start end\" flex>\n      <buddy-dex messages=\"$ctrl.messages\" moi=\"$ctrl.moi\" selected=\"$ctrl.toiUser\" list-toggled=\"$ctrl.onListToggled()\" user-selected=\"$ctrl.onUserSelected(user)\" flex layout=\"column\">\n      </buddy-dex>\n    </md-sidenav>\n\n    <div layout=\"column\" flex>\n      <conversation-thread moi=\"$ctrl.moi\" toi=\"$ctrl.toiUser.scmid\" messages=\"$ctrl.messages\" layout=\"column\" flex>\n      </conversation-thread>\n      <md-divider></md-divider>\n      <mini-submit to=\"$ctrl.toiUser.scmid\" name=\"$ctrl.toiUser.name\">\n      </mini-submit>\n    </div>\n\n    <md-sidenav class=\"md-sidenav-right md-whiteframe-4dp\" md-is-locked-open=\"$mdMedia(\'gt-lg\')\" md-component-id=\"right\" layout=\"column\">\n      <ui-view layout=\"column\" flex></ui-view>\n    </md-sidenav>\n\n  </div><!-- container -->\n</div>\n");
$templateCache.put("app/blurb-action.html","<md-dialog aria-label=\"Blurb Actions\" ng-cloak>\n  <md-dialog-actions>\n    <md-button class=\"md-warn\" ng-click=\"$ctrl.answer(\'delete\')\" aria-label=\"Mark {{Ctrl.message.mid}} deleted\">\n      <md-icon md-svg-icon=\"scmw:delete\"></md-icon>\n    </md-button>\n    <md-button ng-click=\"$ctrl.cancel()\" aria-label=\"Close blurb actions\">\n      Close\n    </md-button>\n  </md-dialog-actions>\n</md-dialog>\n");
$templateCache.put("app/blurb.html","<md-list-item class=\"blurb\" md-colors=\"{\'border-color\': \'primary\'}\" ng-class=\"{\'outgoing-blurb\' : ($ctrl.message.from_scmid.scmid === $ctrl.moi), \'incoming-blurb\' : ($ctrl.message.from_scmid.scmid !== $ctrl.moi)}\" layout-align=\"start start\">\n\n  <!-- has the other guy read this message? -->\n  <div class=\"other-guy\" layout=\"column\">\n    <md-button aria-label=\"Recipient status for {{::$ctrl.message.mid}}\" class=\"md-fab md-mini\" ng-if=\"$ctrl.moi === $ctrl.message.from_scmid.scmid\" ng-disabled=\"true\" ng-repeat=\"toScmid in $ctrl.message.to_scmids\">\n      <!-- The div exists only to make the tootip appear over disabled buttons -->\n      <div class=\"tooltip-over-disabled-workaround\">\n        <md-icon md-svg-icon=\"scmw:new-box\" ng-if=\"toScmid.status === SCMSTAT.NEW\">\n        </md-icon>\n        <md-icon md-svg-icon=\"scmw:truck\" ng-if=\"toScmid.status === SCMSTAT.DELIVERED\">\n        </md-icon>\n        <md-icon md-svg-icon=\"scmw:glasses\" ng-if=\"toScmid.status === SCMSTAT.READ\">\n        </md-icon>\n        <md-icon md-svg-icon=\"scmw:delete\" ng-if=\"toScmid.status === SCMSTAT.DELETED\">\n        </md-icon>\n        <md-tooltip md-direction=\"right\" ng-if=\"toScmid.status === SCMSTAT.NEW\">\n          Waiting to be delivered to {{toScmid.scmid}}\n        </md-tooltip>\n        <md-tooltip md-direction=\"right\" ng-if=\"toScmid.status === SCMSTAT.DELIVERED\">\n          Delivered to {{toScmid.scmid}}\n        </md-tooltip>\n        <md-tooltip md-direction=\"right\" ng-if=\"toScmid.status === SCMSTAT.READ\">\n          {{toScmid.scmid}} has read the message\n        </md-tooltip>\n        <md-tooltip md-direction=\"right\" ng-if=\"toScmid.status === SCMSTAT.DELETED\">\n          {{toScmid.scmid}} deleted the message\n        </md-tooltip>\n      </div>\n    </md-button>\n    <!-- Sender implies read or deleted so why show the status.\n    <md-button aria-label=\"Sender status for {{$ctrl.message.mid}}\"\n      class=\"md-fab md-mini\"\n      ng-if=\"$ctrl.moi !== $ctrl.message.from_scmid.scmid\"\n      ng-disabled=\"true\">\n      <md-icon md-svg-icon=\"scmw:new-box\"\n        ng-if=\"$ctrl.message.from_scmid.status === SCMSTAT.NEW\">\n      </md-icon>\n      <md-icon md-svg-icon=\"scmw:truck\"\n        ng-if=\"$ctrl.message.from_scmid.status === SCMSTAT.DELIVERED\">\n      </md-icon>\n      <md-icon md-svg-icon=\"scmw:glasses\"\n        ng-if=\"$ctrl.message.from_scmid.status === SCMSTAT.READ\">\n      </md-icon>\n      <md-icon md-svg-icon=\"scmw:delete\"\n        ng-if=\"$ctrl.message.from_scmid.status === SCMSTAT.DELETED\">\n      </md-icon>\n    </md-button>\n  -->\n  </div><!-- other-guy -->\n\n  <!-- Toi -->\n  <initial-on name=\"$ctrl.message.from_scmid.name || $ctrl.message.from_scmid.scmid\" uid=\"$ctrl.message.from_scmid.scmid\" ng-if=\"$ctrl.moi != $ctrl.message.from_scmid.scmid\" hide-xs show-gt-sm></initial-on>\n  <!--\n  <md-icon class=\"md-avatar\" md-svg-icon=\"scmw:face-profile\"\n    ng-if=\"$ctrl.moi != $ctrl.message.from_scmid.scmid\"\n    hide-xs show-gt-sm></md-icon>\n  -->\n\n  <!-- The message and notes -->\n  <div flex>\n    <h5>{{$ctrl.message.from_scmid.name || $ctrl.message.from_scmid.scmid}}</h5>\n    <span class=\"mini-to\" ng-if=\"(($ctrl.toi == $ctrl.moi) && ($ctrl.moi == $ctrl.message.from_scmid.scmid))\">\n      wrote\n      <span ng-repeat=\"toScmid in $ctrl.message.to_scmids\">\n        {{toScmid.name || toScmid.scmid}}\n      </span>\n    </span>\n    <span class=\"mini-stamp\">{{::$ctrl.message.created * 1000 | date:\'yyyy-MM-dd HH:mm:ss\'}}</span>\n    <br>\n\n    <p>{{::$ctrl.message.message}}</p>\n\n    <md-whiteframe ng-if=\"$ctrl.message.note.note\" class=\"md-whiteframe-z1 inline-note\" layout=\"row\" layout-align=\"start start\">\n      <div flex>{{$ctrl.message.note.note}}</div>\n      <md-button aria-label=\"Edit note for {{::$ctrl.message.mid}}\" class=\"md-icon-button\" ng-click=\"$ctrl.editNote()\">\n        <md-icon md-svg-icon=\"scmw:note-text\"></md-icon>\n      </md-button>\n    </md-whiteframe>\n  </div><!-- flex -->\n\n  <!-- moi -->\n  <!--\n  <md-icon class=\"moi-button md-avatar\" md-svg-icon=\"scmw:face\"\n    ng-if=\"$ctrl.moi === $ctrl.message.from_scmid.scmid\"\n    hide-xs show-gt-sm></md-icon>\n  -->\n\n  <!-- Have I read it? Want to make a note? action buttons-->\n  <div layout=\"column\" layout-align=\"start center\">\n    <md-button aria-label=\"Per-message menu\" class=\"md-fab md-mini\" ng-if=\"$ctrl.moi !== $ctrl.message.from_scmid.scmid\" ng-repeat=\"toScmid in $ctrl.message.to_scmids | filter:{scmid:$ctrl.moi}\" ng-click=\"$ctrl.buttonClicked($event, toScmid.status)\">\n      <md-icon md-svg-icon=\"scmw:new-box\" ng-if=\"toScmid.status === SCMSTAT.NEW\"></md-icon>\n      <md-icon md-svg-icon=\"scmw:truck\" ng-if=\"toScmid.status === SCMSTAT.DELIVERED\"></md-icon>\n      <md-icon md-svg-icon=\"scmw:glasses\" ng-if=\"toScmid.status === SCMSTAT.READ\"></md-icon>\n      <md-icon md-svg-icon=\"scmw:delete\" ng-if=\"toScmid.status === SCMSTAT.DELETED\"></md-icon>\n      <md-tooltip md-direction=\"below\" ng-if=\"toScmid.status === SCMSTAT.NEW\">\n        New - Press to mark delivered\n      </md-tooltip>\n      <md-tooltip md-direction=\"below\" ng-if=\"toScmid.status === SCMSTAT.DELIVERED\">\n        Delivered - Press to mark read\n      </md-tooltip>\n      <md-tooltip md-direction=\"below\" ng-if=\"toScmid.status === SCMSTAT.READ\">\n        Read - Press to mark deleted\n      </md-tooltip>\n      <md-tooltip md-direction=\"below\" ng-if=\"toScmid.status === SCMSTAT.DELETED\">\n        Deleted\n      </md-tooltip>\n    </md-button>\n    <md-button aria-label=\"Per-message menu\" class=\"md-fab md-mini\" ng-if=\"$ctrl.moi === $ctrl.message.from_scmid.scmid\" ng-click=\"$ctrl.buttonClicked($event, $ctrl.message.from_scmid.status)\">\n      <md-icon md-svg-icon=\"scmw:new-box\" ng-if=\"$ctrl.message.from_scmid.status === SCMSTAT.NEW\"></md-icon>\n      <md-icon md-svg-icon=\"scmw:truck\" ng-if=\"$ctrl.message.from_scmid.status === SCMSTAT.DELIVERED\"></md-icon>\n      <md-icon md-svg-icon=\"scmw:glasses\" ng-if=\"$ctrl.message.from_scmid.status === SCMSTAT.READ\"></md-icon>\n      <md-icon md-svg-icon=\"scmw:delete\" ng-if=\"$ctrl.message.from_scmid.status === SCMSTAT.DELETED\"></md-icon>\n      <md-tooltip md-direction=\"below\" ng-if=\"$ctrl.message.from_scmid.status === SCMSTAT.NEW\">\n        New - Press to mark delivered\n      </md-tooltip>\n      <md-tooltip md-direction=\"below\" ng-if=\"$ctrl.message.from_scmid.status === SCMSTAT.DELIVERED\">\n        Delivered - Press to mark read\n      </md-tooltip>\n      <md-tooltip md-direction=\"below\" ng-if=\"$ctrl.message.from_scmid.status === SCMSTAT.READ\">\n        Read - Press to mark deleted\n      </md-tooltip>\n      <md-tooltip md-direction=\"below\" ng-if=\"$ctrl.message.from_scmid.status === SCMSTAT.DELETED\">\n        Deleted\n      </md-tooltip>\n    </md-button>\n    <md-button aria-label=\"Edit note for {{::$ctrl.message.mid}}\" class=\"notes md-icon-button md-raised\" ng-click=\"$ctrl.editNote()\" ng-disabled=\"($ctrl.message.mid <= 0)\">\n      <md-icon ng-if=\"!$ctrl.message.note.note\" md-svg-icon=\"scmw:note-plus\"></md-icon>\n      <md-icon ng-if=\"$ctrl.message.note.note\" md-svg-icon=\"scmw:note-text\"></md-icon>\n      <md-tooltip md-direction=\"below\" ng-if=\"!$ctrl.message.note.note\">Add Note</md-tooltip>\n      <md-tooltip md-direction=\"below\" ng-if=\"$ctrl.message.note.note\">Edit Note</md-tooltip>\n    </md-button>\n  </div>\n  <md-divider inset></md-divider>\n</md-list-item>\n");
$templateCache.put("app/buddy-dex.html","<md-list ng-click=\"$ctrl.toggleList()\" flex>\n  <!-- for each users in users list -->\n  <md-list-item ng-repeat=\"u in $ctrl.users\">\n    <div class=\"for-ie-flexing\" layout=\"column\" flex>\n      <md-button ng-click=\"$ctrl.selectUser(u)\" ng-class=\"{\'md-primary md-hue-2 selected\': u.scmid === $ctrl.selected.scmid}\">\n        <div layout=\"row\" flex>\n          <initial-on name=\"u.name || u.scmid\" uid=\"u.scmid\"></initial-on>\n          <!--\n          <md-icon class=\"md-avatar-icon\"\n            md-svg-icon=\"scmw:face\"\n            ng-if=\"u.scmid === $ctrl.moi\">\n          </md-icon>\n          <md-icon class=\"md-avatar-icon\"\n            md-svg-icon=\"scmw:face-profile\"\n            ng-if=\"u.scmid !== $ctrl.moi\">\n          </md-icon>\n        -->\n          <md-truncate flex>{{u.name || u.scmid}}</md-truncate>\n          <md-radio-group ng-if=\"u.count\" ng-model=\"oneAndOnly\" ng-init=\"oneAndOnly= 1\" class=\"unread\">\n            <md-radio-button ng-value=\"1\" aria-label=\"\"><span>{{u.count}}, {{u.created | intervalAgo}} ago</span></md-radio-button>\n          </md-radio-group>\n            <!--\n            <div layout=\"column\">\n            <md-chips ng-show=\"u.count\">\n              <md-chip readonly>\n                {{u.count}}, {{u.created | intervalAgo}} ago\n              </md-chip>\n            </md-chips>\n            </div>\n          -->\n        </div>\n      </md-button>\n    </div> <!-- for-ie-flexing -->\n  </md-list-item>\n</md-list>\n<md-button class=\"md-fab md-accent full-compose-button\" ng-click=\"$ctrl.fullComposeClick($event)\" aria-label=\"Compose messages\">\n  <md-icon md-svg-src=\"lead-pencil\"></md-icon>\n</md-button>\n");
$templateCache.put("app/contact-whom.html","<md-chips ng-model=\"$ctrl.tos\" name=\"contactWhom\" md-autocomplete-wrap-override md-autocomplete-snap=\"width\" md-transform-chip=\"$ctrl.transformChip($chip)\" md-require-match=\"false\">\n  <md-autocomplete md-selected-item=\"$ctrl.selectedItem\" md-search-text=\"$ctrl.searchText\" md-items=\"item in $ctrl.querySearch($ctrl.searchText)\" md-item-text=\"item.scmid\" placeholder=\"{{($ctrl.tos.length) ? \'+Recipient\':\'Type/choose recipient\'}}\">\n      <span md-highlight-text=\"$ctrl.searchText\">\n        {{item.scmid}}{{item.name ? \'::\':\'\'}}{{item.name}}{{item.curated ? \'(curated)\':\'\'}}\n      </span>\n  </md-autocomplete>\n  <md-chip-template>\n    <span>\n      <strong>{{$chip.name || $chip.scmid}}</strong>\n    </span>\n  </md-chip-template>\n</md-chips>\n");
$templateCache.put("app/conversation-thread.html","<div class=\"conversation-thread\" layout=\"column\" flex>\n  <md-list>\n    <blurb ng-repeat=\"m in $ctrl.messages | toAndFrom:$ctrl.toi\" id=\"mid-{{m.mid}}\" message=\"m\" moi=\"$ctrl.moi\" toi=\"$ctrl.toi\">\n    </blurb>\n  </md-list>\n</div><!-- converstation-thread -->\n");
$templateCache.put("app/full-compose-dialog.html","<md-dialog class=\"full-compose-dialog\" aria-label=\"Blurb Actions\" ng-cloak>\n  <md-toolbar>\n    <div class=\"md-toolbar-tools\">\n      <h2>Compose a message</h2>\n      <span flex></span>\n      <md-button class=\"md-icon-button\" ng-click=\"$ctrl.closeDialog()\">\n        <md-icon md-svg-src=\"close\" aria-label=\"Close dialog\"></md-icon>\n      </md-button>\n    </div>\n  </md-toolbar>\n  <md-dialog-content layout-padding flex>\n    <form ng-submit=\"$ctrl.sendMessage()\" layout=\"column\" flex>\n      <contact-whom contacts=\"$ctrl.contacts\" tos=\"$ctrl.tos\" flex>\n      </contact-whom><br>\n      <!-- IE11 needs this extra, useless md-input-container -->\n      <md-input-container></md-input-container>\n      <md-input-container flex>\n        <label>Message</label>\n        <textarea style=\"resize: none\" ng-model=\"$ctrl.composition\" rows=\"3\" placeholder=\"Write a message {{\'\\n\\n\'}}\" md-select-on-focus flex>\n        </textarea>\n      </md-input-container>\n    </form>\n  </md-dialog-content>\n  <md-dialog-actions>\n    <md-button class=\"md-alert md-hue-1 md-fab md-mini\" ng-click=\"$ctrl.closeDialog()\" aria-label=\"Close compose dialog\">\n      <md-icon md-svg-icon=\"close\"></md-icon>\n    </md-button>\n    <md-button class=\"md-fab md-mini md-icon-button md-raised md-accent\" aria-label=\"Send composed message\" ng-click=\"$ctrl.sendMessage()\">\n      <md-icon md-svg-icon=\"send\" layout=\"column\"></md-icon>\n    </md-button>\n  </md-dialog-actions>\n</md-dialog>\n");
$templateCache.put("app/full-compose-editor.html","<md-toolbar>\n  <h1 class=\"md-toolbar-tools\">Compose A Message</h1>\n</md-toolbar>\n<md-content layout-padding=\"\" flex>\n\n  <form ng-submit=\"$ctrl.send()\" name=\"$ctrl.composeForm\" layout=\"column\" flex>\n\n    <md-input-container>\n      <contact-whom contacts=\"$ctrl.contacts\" tos=\"$ctrl.tos\" flex>\n      </contact-whom><br>\n    </md-input-container>\n\n    <!-- IE11 needs this extra, useless md-input-container -->\n    <md-input-container></md-input-container>\n\n    <!-- IE11 needs this extra md-whiteframe or else the textarea bleeds into the buttons -->\n    <md-whiteframe class=\"md-whiteframe-z1\" layout layout-align=\"center center\">\n      <md-input-container flex>\n        <label>Message</label>\n        <textarea name=\"composition\" ng-model=\"$ctrl.composition\" placeholder=\"Write a message\" md-select-on-focus required flex>\n        </textarea>\n        <div ng-messages=\"$ctrl.composeForm.composition.$error\">\n          <ng-message when=\"required\">Write a message.</ng-message>\n          <ng-message when=\"tos\">Choose recipients.</ng-message>\n        </div>\n      </md-input-container>\n    </md-whiteframe>\n  </form>\n  <md-button ng-click=\"$ctrl.send()\" class=\"md-accent md-raised\" ng-disabled=\"$ctrl.composeForm.$invalid || $ctrl.tos.length <= 0\">\n    Send\n  </md-button>\n  <md-button ng-click=\"$ctrl.cancel()\">\n    Cancel\n  </md-button>\n</md-content>\n");
$templateCache.put("app/initial-on.html","<md-whiteframe class=\"initials md-whiteframe-1dp\" layout=\"row\" layout-align=\"center center\" md-colors=\"{\'background-color\': \'primary-hue-3\'}\">\n  {{$ctrl.name | initials}}\n</md-whiteframe>\n");
$templateCache.put("app/login.html","<link ng-if=\"$ctrl.fontUrl\" ng-href=\"{{$ctrl.fontUrl}}\" rel=\"stylesheet\" type=\"text/css\">\n<form class=\"login-form\" name=\"$ctrl.loginForm\" ng-submit=\"$ctrl.login()\" role=\"form\" layout=\"column\" flex>\n  <md-content md-theme=\"dark-default\" layout=\"column\" flex>\n    <div layout=\"row\" flex=\"35\" layout-align=\"center center\">\n      <h1 class=\"title-header\" ng-if=\"$ctrl.title\" style=\"font-family: {{$ctrl.fontFamily}}\">{{$ctrl.title}}</h1>\n    </div><!-- flex-35 -->\n    <div layout=\"column\" flex=\"65\">\n      <div layout-xs=\"column\" layout-align-xs=\"start center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"center-start\">\n        <md-input-container class=\"md-icon-float\">\n          <!-- Use floating label instead of placeholder -->\n          <label>User-name</label>\n          <md-icon md-svg-src=\"account\"></md-icon>\n          <input type=\"text\" name=\"username\" ng-model=\"$ctrl.username\" required>\n          <div ng-messages=\"$ctrl.loginForm.username.$error\">\n            <ng-message when=\"required\">Supply a user-name.</ng-message>\n          </div>\n        </md-input-container>\n        <md-input-container class=\"md-icon-float\">\n          <label>Password</label>\n          <md-icon md-svg-src=\"key\"></md-icon>\n          <input type=\"password\" name=\"password\" ng-model=\"$ctrl.password\" required>\n          <div ng-messages=\"$ctrl.loginForm.password.$error\">\n            <ng-message when=\"required\">Supply a password.</ng-message>\n          </div>\n        </md-input-container>\n          <md-button class=\"md-accent\" ng-click=\"$ctrl.login()\" md-no-ink aria-label=\"Login button\">\n          <md-icon md-svg-icon=\"login-variant\"></md-icon>\n          <span>Login</span>\n        </md-button>\n      </div><!-- layout-xs layout-gt-xs -->\n      <div class=\"error-message\" layout=\"column\" layout=\"center center\">\n        <span ng-if=\"$ctrl.error\">{{$ctrl.error}}</span>\n      </div><!-- error-message -->\n    </div><!-- flex-65 -->\n\n    <div class=\"marketing\" layout=\"row\" layout-align=\"center center\">\n      <div class=\"google-play\" ng-if=\"$ctrl.googlePlayUrl\">\n        <a ng-href=\"{{$ctrl.googlePlayUrl}}\"><img alt=\"Get it on Google Play\" src=\"https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png\"></a>\n      </div>\n      <div class=\"app-store\" ng-if=\"$ctrl.appStoreUrl\">\n        <a ng-href=\"{{$ctrl.appStoreUrl}}\"><img alt=\"Download on the App Store\" src=\"./assets/img/Download_on_the_App_Store_Badge_US-UK_135x40.svg\"></a>\n      </div>\n    </div> <!-- marketing -->\n  </md-content>\n</form>\n");
$templateCache.put("app/mini-submit.html","<div class=\"mini-submit\" flex=\"none\">\n  <form ng-submit=\"$ctrl.sendMessage()\" flex layout=\"row\">\n    <md-input-container class=\"composition\" flex>\n      <label>Message</label>\n      <textarea style=\"resize: none\" ng-model=\"$ctrl.composition\" rows=\"2\" placeholder=\"Write {{($ctrl.name || $ctrl.to)  + \'\\n\\n\'}}\" md-no-autgrow=\"true\" md-select-on-focus aria-label=\"Write {{$ctrl.name || $ctrl.to}}\" flex>\n      </textarea>\n    </md-input-container>\n    <md-input-container class=\"send-button-container\">\n      <md-button class=\"md-fab md-accent md-raised\" aria-label=\"Send message to {{$ctrl.to}}\" ng-click=\"$ctrl.sendMessage()\">\n        <md-icon md-svg-icon=\"send\" layout=\"column\"></md-icon>\n      </md-button>\n    </md-input-container>\n  </form>\n</div><!-- flex-none -->\n");
$templateCache.put("app/no-editor.html","<md-content layout-padding=\"\" flex>\n</md-content>\n");
$templateCache.put("app/note-editor.html","<md-toolbar>\n  <h1 class=\"md-toolbar-tools\">Edit Note</h1>\n</md-toolbar>\n<md-content layout-padding=\"\" flex>\n  <p>{{$ctrl.message.message}}</p>\n  <md-whiteframe class=\"md-whiteframe-z1\" layout layout-align=\"center center\">\n    <form flex layout=\"column\">\n      <md-input-container>\n        <label>Note</label>\n        <textarea ng-model=\"$ctrl.composition\" class=\"note-area\" placeholder=\"Make a note\" flex md-autofocus></textarea>\n      </md-input-container>\n    </form>\n  </md-whiteframe>\n  <md-button ng-click=\"$ctrl.save()\" class=\"md-accent md-raised\">\n    Save\n  </md-button>\n  <md-button ng-click=\"$ctrl.cancel()\">\n    Cancel\n  </md-button>\n</md-content>\n");}]);
(function () {
  angular
    .module('app')
    .config(routesConfig)
    .run(runOnState);


  routesConfig.$inject = ['$stateProvider', '$urlRouterProvider',
      '$locationProvider'];
  /**
   * Configure the app's states.
   *
   * @param {Object} $stateProvider the ui-router state provider
   * @param {Object} $urlRouterProvider the  angular url router provider
   * @param {Object} $locationProvider the angular location provider
   */
  function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    /* ui-router does not like having a hashPrefix so the following is
     * commented out */
    /* $locationProvider.html5Mode(true).hashPrefix('!'); */
    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('login', {
        url: '/login',
        params: {
          error: ''
        },
        template: '<login layout="column" flex></login>'
      })
      .state('app', {
        url: '/',
        template: '<app layout="column" flex></app>'
      })
      .state('app.index', {
        template: '<no-editor layout="column" flex></no-editor>'
      })
      .state('app.note-editor', {
        params: {
          message: null
        },
        template: '<note-editor message="$resolve.message" layout="column" flex></note-editor>',
        resolve: {
          message: ['$stateParams', function ($stateParams) {
            return $stateParams.message;
          }],
          note: ['$stateParams', 'scmService', function ($stateParams,
            scmService) {
            return scmService.getNote($stateParams.message.mid);
          }]
        }
      })
      .state('app.full-compose-editor', {
        params: {
          correspondents: null
        },
        template: '<full-compose-editor contacts="$resolve.contacts" layout="column" flex></full-compose-editor>',
        resolve: {
          contacts: ['$stateParams', 'scmService', function ($stateParams, scmService) {
            return scmService.fuseContacts($stateParams.correspondents);
          }]
        }
      })
      .state('account', {
        url: '/account',
        template: '<account-settings layout="column" flex></account-settings>',
      });
  } /* routesConfig */


  runOnState.$inject = ['$log', '$rootScope'];
  /**
   * Registerer event handlers.
   *
   * @param {Object} $log the angular logging object
   * @param {Object} $rootScope the angular root scope
   */
  function runOnState($log, $rootScope) {
    $rootScope.$on('$stateChangeError', onStateChangeError);

    /**
     * Print out any ui-router errors including resolve errors.
     *
     *
     * @param {Object} event the javascript event
     * @param {String} toState the next state???
     * @param {Object} toParams the params
     * @param {String} fromState the from state
     * @param {Object} fromParams the from params
     * @param {Object} error the error parameters
     */
    function onStateChangeError(event, toState, toParams, fromState, fromParams,
      error) {
      $log.error("$statChangeError", error);
      return;
    } /* onStateChangeError */
  } /* runOnState */
})();
